//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAddressClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    addressesGET(email: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    addressesPOST(email: string, loggedInUsername: any | undefined, body: AddressModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    addressesPUT(email: string, loggedInUsername: any | undefined, body: AddressModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    addressesGET2(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    addressesGET3(requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param addressId (optional) 
     * @param addressLine1 (optional) 
     * @param addressLine2 (optional) 
     * @param addressLine3 (optional) 
     * @param city (optional) 
     * @param state (optional) 
     * @param countryId (optional) 
     * @param officePhone1 (optional) 
     * @param officePhone2 (optional) 
     * @param homePhone1 (optional) 
     * @param homePhone2 (optional) 
     * @param mobile (optional) 
     * @param postalCode (optional) 
     * @param isActive (optional) 
     * @param isActiveDirectoryAddress (optional) 
     * @param country (optional) 
     * @param isDeletedAddress (optional) 
     * @param parentAddressId (optional) 
     * @param isParentUpdated (optional) 
     * @param isParentDeleted (optional) 
     * @param isDefaultAddress (optional) 
     * @param recipientId (optional) 
     * @param orgName (optional) 
     * @param modifiedBy (optional) 
     * @param modifiedAt (optional) 
     * @param isIndyAligned (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    validateUSPSAddress(addressId: number | undefined, addressLine1: string | undefined, addressLine2: string | undefined, addressLine3: string | undefined, city: string | undefined, state: string | undefined, countryId: number | undefined, officePhone1: string | undefined, officePhone2: string | undefined, homePhone1: string | undefined, homePhone2: string | undefined, mobile: string | undefined, postalCode: string | undefined, isActive: boolean | undefined, isActiveDirectoryAddress: boolean | undefined, country: string | undefined, isDeletedAddress: boolean | undefined, parentAddressId: number | undefined, isParentUpdated: boolean | undefined, isParentDeleted: boolean | undefined, isDefaultAddress: boolean | undefined, recipientId: number | undefined, orgName: string | undefined, modifiedBy: string | undefined, modifiedAt: Date | undefined, isIndyAligned: boolean | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getStateAndCity(zip: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class AddressClient implements IAddressClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    addressesGET(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/{email}/addresses";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    addressesPOST(email: string, loggedInUsername: any | undefined, body: AddressModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/{email}/addresses";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    addressesPUT(email: string, loggedInUsername: any | undefined, body: AddressModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/{email}/addresses";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    addressesGET2(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/addresses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    addressesGET3(requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestnumber}/addresses";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param addressId (optional) 
     * @param addressLine1 (optional) 
     * @param addressLine2 (optional) 
     * @param addressLine3 (optional) 
     * @param city (optional) 
     * @param state (optional) 
     * @param countryId (optional) 
     * @param officePhone1 (optional) 
     * @param officePhone2 (optional) 
     * @param homePhone1 (optional) 
     * @param homePhone2 (optional) 
     * @param mobile (optional) 
     * @param postalCode (optional) 
     * @param isActive (optional) 
     * @param isActiveDirectoryAddress (optional) 
     * @param country (optional) 
     * @param isDeletedAddress (optional) 
     * @param parentAddressId (optional) 
     * @param isParentUpdated (optional) 
     * @param isParentDeleted (optional) 
     * @param isDefaultAddress (optional) 
     * @param recipientId (optional) 
     * @param orgName (optional) 
     * @param modifiedBy (optional) 
     * @param modifiedAt (optional) 
     * @param isIndyAligned (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    validateUSPSAddress(addressId: number | undefined, addressLine1: string | undefined, addressLine2: string | undefined, addressLine3: string | undefined, city: string | undefined, state: string | undefined, countryId: number | undefined, officePhone1: string | undefined, officePhone2: string | undefined, homePhone1: string | undefined, homePhone2: string | undefined, mobile: string | undefined, postalCode: string | undefined, isActive: boolean | undefined, isActiveDirectoryAddress: boolean | undefined, country: string | undefined, isDeletedAddress: boolean | undefined, parentAddressId: number | undefined, isParentUpdated: boolean | undefined, isParentDeleted: boolean | undefined, isDefaultAddress: boolean | undefined, recipientId: number | undefined, orgName: string | undefined, modifiedBy: string | undefined, modifiedAt: Date | undefined, isIndyAligned: boolean | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/ValidateUSPSAddress?";
        if (addressId === null)
            throw new Error("The parameter 'addressId' cannot be null.");
        else if (addressId !== undefined)
            url_ += "AddressId=" + encodeURIComponent("" + addressId) + "&";
        if (addressLine1 === null)
            throw new Error("The parameter 'addressLine1' cannot be null.");
        else if (addressLine1 !== undefined)
            url_ += "AddressLine1=" + encodeURIComponent("" + addressLine1) + "&";
        if (addressLine2 === null)
            throw new Error("The parameter 'addressLine2' cannot be null.");
        else if (addressLine2 !== undefined)
            url_ += "AddressLine2=" + encodeURIComponent("" + addressLine2) + "&";
        if (addressLine3 === null)
            throw new Error("The parameter 'addressLine3' cannot be null.");
        else if (addressLine3 !== undefined)
            url_ += "AddressLine3=" + encodeURIComponent("" + addressLine3) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (officePhone1 === null)
            throw new Error("The parameter 'officePhone1' cannot be null.");
        else if (officePhone1 !== undefined)
            url_ += "OfficePhone1=" + encodeURIComponent("" + officePhone1) + "&";
        if (officePhone2 === null)
            throw new Error("The parameter 'officePhone2' cannot be null.");
        else if (officePhone2 !== undefined)
            url_ += "OfficePhone2=" + encodeURIComponent("" + officePhone2) + "&";
        if (homePhone1 === null)
            throw new Error("The parameter 'homePhone1' cannot be null.");
        else if (homePhone1 !== undefined)
            url_ += "HomePhone1=" + encodeURIComponent("" + homePhone1) + "&";
        if (homePhone2 === null)
            throw new Error("The parameter 'homePhone2' cannot be null.");
        else if (homePhone2 !== undefined)
            url_ += "HomePhone2=" + encodeURIComponent("" + homePhone2) + "&";
        if (mobile === null)
            throw new Error("The parameter 'mobile' cannot be null.");
        else if (mobile !== undefined)
            url_ += "Mobile=" + encodeURIComponent("" + mobile) + "&";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "PostalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isActiveDirectoryAddress === null)
            throw new Error("The parameter 'isActiveDirectoryAddress' cannot be null.");
        else if (isActiveDirectoryAddress !== undefined)
            url_ += "IsActiveDirectoryAddress=" + encodeURIComponent("" + isActiveDirectoryAddress) + "&";
        if (country === null)
            throw new Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (isDeletedAddress === null)
            throw new Error("The parameter 'isDeletedAddress' cannot be null.");
        else if (isDeletedAddress !== undefined)
            url_ += "IsDeletedAddress=" + encodeURIComponent("" + isDeletedAddress) + "&";
        if (parentAddressId === null)
            throw new Error("The parameter 'parentAddressId' cannot be null.");
        else if (parentAddressId !== undefined)
            url_ += "ParentAddressId=" + encodeURIComponent("" + parentAddressId) + "&";
        if (isParentUpdated === null)
            throw new Error("The parameter 'isParentUpdated' cannot be null.");
        else if (isParentUpdated !== undefined)
            url_ += "IsParentUpdated=" + encodeURIComponent("" + isParentUpdated) + "&";
        if (isParentDeleted === null)
            throw new Error("The parameter 'isParentDeleted' cannot be null.");
        else if (isParentDeleted !== undefined)
            url_ += "IsParentDeleted=" + encodeURIComponent("" + isParentDeleted) + "&";
        if (isDefaultAddress === null)
            throw new Error("The parameter 'isDefaultAddress' cannot be null.");
        else if (isDefaultAddress !== undefined)
            url_ += "IsDefaultAddress=" + encodeURIComponent("" + isDefaultAddress) + "&";
        if (recipientId === null)
            throw new Error("The parameter 'recipientId' cannot be null.");
        else if (recipientId !== undefined)
            url_ += "RecipientId=" + encodeURIComponent("" + recipientId) + "&";
        if (orgName === null)
            throw new Error("The parameter 'orgName' cannot be null.");
        else if (orgName !== undefined)
            url_ += "OrgName=" + encodeURIComponent("" + orgName) + "&";
        if (modifiedBy === null)
            throw new Error("The parameter 'modifiedBy' cannot be null.");
        else if (modifiedBy !== undefined)
            url_ += "ModifiedBy=" + encodeURIComponent("" + modifiedBy) + "&";
        if (modifiedAt === null)
            throw new Error("The parameter 'modifiedAt' cannot be null.");
        else if (modifiedAt !== undefined)
            url_ += "ModifiedAt=" + encodeURIComponent(modifiedAt ? "" + modifiedAt.toISOString() : "") + "&";
        if (isIndyAligned === null)
            throw new Error("The parameter 'isIndyAligned' cannot be null.");
        else if (isIndyAligned !== undefined)
            url_ += "IsIndyAligned=" + encodeURIComponent("" + isIndyAligned) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateUSPSAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateUSPSAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateUSPSAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getStateAndCity(zip: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/GetStateAndCity/{zip}";
        if (zip === undefined || zip === null)
            throw new Error("The parameter 'zip' must be defined.");
        url_ = url_.replace("{zip}", encodeURIComponent("" + zip));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStateAndCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStateAndCity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetStateAndCity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestShipmentClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    addressesPOST2(requestNumber: string, loggedInUsername: any | undefined, body: ShipmentAddressModel | undefined): Observable<void>;
    /**
     * @param recipientType (optional) 
     * @param recipientEmail (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    shippingdetail(recipientType: RecipientType | undefined, requestNumber: string, recipientEmail: string | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param recipientType (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    reqesterDetails(recipientType: RecipientType | undefined, requesterEmail: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestShipmentClient implements IRequestShipmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    addressesPOST2(requestNumber: string, loggedInUsername: any | undefined, body: ShipmentAddressModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestnumber}/addresses";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressesPOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressesPOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddressesPOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param recipientType (optional) 
     * @param recipientEmail (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    shippingdetail(recipientType: RecipientType | undefined, requestNumber: string, recipientEmail: string | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestnumber}/shippingdetail?";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        if (recipientType === null)
            throw new Error("The parameter 'recipientType' cannot be null.");
        else if (recipientType !== undefined)
            url_ += "recipientType=" + encodeURIComponent("" + recipientType) + "&";
        if (recipientEmail === null)
            throw new Error("The parameter 'recipientEmail' cannot be null.");
        else if (recipientEmail !== undefined)
            url_ += "recipientEmail=" + encodeURIComponent("" + recipientEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShippingdetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShippingdetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processShippingdetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param recipientType (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    reqesterDetails(recipientType: RecipientType | undefined, requesterEmail: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requesterEmail}/reqesterDetails?";
        if (requesterEmail === undefined || requesterEmail === null)
            throw new Error("The parameter 'requesterEmail' must be defined.");
        url_ = url_.replace("{requesterEmail}", encodeURIComponent("" + requesterEmail));
        if (recipientType === null)
            throw new Error("The parameter 'recipientType' cannot be null.");
        else if (recipientType !== undefined)
            url_ += "recipientType=" + encodeURIComponent("" + recipientType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReqesterDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReqesterDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReqesterDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IAlchemistClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    orderUpdates(loggedInUsername: any | undefined, body: OrderDetailMessage[] | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    orderDetails(requestType: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    uOMConvert(loggedInUsername: any | undefined, body: UOMItemConversion | undefined): Observable<UOMConversion>;
}

@Injectable({
    providedIn: 'root'
})
export class AlchemistClient implements IAlchemistClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    orderUpdates(loggedInUsername: any | undefined, body: OrderDetailMessage[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/OrderUpdates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderUpdates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderUpdates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderUpdates(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    orderDetails(requestType: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/OrderDetails/{requesttype}/{requestnumber}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOrderDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    uOMConvert(loggedInUsername: any | undefined, body: UOMItemConversion | undefined): Observable<UOMConversion> {
        let url_ = this.baseUrl + "/UOMConvert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUOMConvert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUOMConvert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UOMConversion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UOMConversion>;
        }));
    }

    protected processUOMConvert(response: HttpResponseBase): Observable<UOMConversion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = UOMConversion.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UOMConversion>(null as any);
    }
}

export interface IAuthenticationClient {
    /**
     * @param userName (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    user(userName: string | undefined, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticationClient implements IAuthenticationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userName (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    user(userName: string | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/authentication/user?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IAzureAdClient {
    /**
     * @param searchString (optional) 
     * @param includeDistributionLists (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    search(searchString: string | undefined, includeDistributionLists: boolean | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    manager(email: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class AzureAdClient implements IAzureAdClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param searchString (optional) 
     * @param includeDistributionLists (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    search(searchString: string | undefined, includeDistributionLists: boolean | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/azure-ad/users/search?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        if (includeDistributionLists === null)
            throw new Error("The parameter 'includeDistributionLists' cannot be null.");
        else if (includeDistributionLists !== undefined)
            url_ += "includeDistributionLists=" + encodeURIComponent("" + includeDistributionLists) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    manager(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/azure-ad/users/{email}/manager";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManager(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManager(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processManager(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ICartItemClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    forCurrentUser(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    cartItemsPOST(requestType: string, loggedInUsername: any | undefined, body: SaveCartItemModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    cartItemsDELETE(requestType: string, cartItemId: number, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CartItemClient implements ICartItemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    forCurrentUser(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/carts/cart-items/for-current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForCurrentUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    cartItemsPOST(requestType: string, loggedInUsername: any | undefined, body: SaveCartItemModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/carts/cart-items";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCartItemsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCartItemsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCartItemsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    cartItemsDELETE(requestType: string, cartItemId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/carts/cart-items/{cartitemid}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (cartItemId === undefined || cartItemId === null)
            throw new Error("The parameter 'cartItemId' must be defined.");
        url_ = url_.replace("{cartItemId}", encodeURIComponent("" + cartItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCartItemsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCartItemsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCartItemsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IChemicalSearchClient {
    /**
     * @param criteria (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    chemicals(requestType: string, criteria: string | undefined, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ChemicalSearchClient implements IChemicalSearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param criteria (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    chemicals(requestType: string, criteria: string | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/search/chemicals?";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (criteria === null)
            throw new Error("The parameter 'criteria' cannot be null.");
        else if (criteria !== undefined)
            url_ += "criteria=" + encodeURIComponent("" + criteria) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChemicals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChemicals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChemicals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ICountryClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    countries(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    countries2(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class CountryClient implements ICountryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    countries(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCountries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    countries2(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/shipping-addresses/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCountries2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IDataTypeClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    datatypesGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    datatypesPOST(loggedInUsername: any | undefined, body: DataTypeModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class DataTypeClient implements IDataTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    datatypesGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/datatypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatatypesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatatypesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatatypesGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    datatypesPOST(loggedInUsername: any | undefined, body: DataTypeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/datatypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatatypesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatatypesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatatypesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IEmailMessageLogClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    emailmessagelogsGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    emailmessagelogsPOST(loggedInUsername: any | undefined, body: EmailMessageLogModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    reSend(loggedInUsername: any | undefined, body: EmailMessageLogModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailMessageLogClient implements IEmailMessageLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    emailmessagelogsGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emailmessagelogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailmessagelogsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailmessagelogsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailmessagelogsGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    emailmessagelogsPOST(loggedInUsername: any | undefined, body: EmailMessageLogModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emailmessagelogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailmessagelogsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailmessagelogsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailmessagelogsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    reSend(loggedInUsername: any | undefined, body: EmailMessageLogModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/notifications/re-send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReSend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReSend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IExceptionLogClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    exceptionlogsGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    exceptionlogsPOST(loggedInUsername: any | undefined, body: ExceptionLogModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ExceptionLogClient implements IExceptionLogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    exceptionlogsGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/exceptionlogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExceptionlogsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExceptionlogsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExceptionlogsGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    exceptionlogsPOST(loggedInUsername: any | undefined, body: ExceptionLogModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/exceptionlogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExceptionlogsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExceptionlogsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExceptionlogsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IExternalRecipientClient {
    /**
     * @param searchString (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    search2(searchString: string | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    externalGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    externalPOST(loggedInUsername: any | undefined, body: ExternalRecipientModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    externalPUT(loggedInUsername: any | undefined, body: ExternalRecipientModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    externalGET2(email: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    externalGET3(email: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ExternalRecipientClient implements IExternalRecipientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param searchString (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    search2(searchString: string | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/external/search?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSearch2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    externalGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/external";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    externalPOST(loggedInUsername: any | undefined, body: ExternalRecipientModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/external";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    externalPUT(loggedInUsername: any | undefined, body: ExternalRecipientModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/external";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    externalGET2(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/{email}/recipients/external";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    externalGET3(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/{email}/external";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IFavoriteClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    favoritesGET(userId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    favoritesPOST(requestNumber: string, loggedInUsername: any | undefined, body: FavoriteModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    favoritesDELETE(favoriteId: number, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class FavoriteClient implements IFavoriteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    favoritesGET(userId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/{userid}/requests/favorites";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFavoritesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFavoritesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFavoritesGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    favoritesPOST(requestNumber: string, loggedInUsername: any | undefined, body: FavoriteModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestnumber}/favorites";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFavoritesPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFavoritesPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFavoritesPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    favoritesDELETE(favoriteId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/favorites/{favoriteid}";
        if (favoriteId === undefined || favoriteId === null)
            throw new Error("The parameter 'favoriteId' must be defined.");
        url_ = url_.replace("{favoriteId}", encodeURIComponent("" + favoriteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFavoritesDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFavoritesDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFavoritesDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IForecastClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    forecasts(email: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    paginatedForecasts(loggedInUsername: any | undefined, body: ForecastRequestModel | undefined): Observable<ForecastResponseModel>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    forecasts2(requestlocationid: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getUsedQuantity(farmLocationId: number, farmInventoryLocation: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getAdvancedQuantity(farmLocationId: number, uom: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    samplerequesthistory(requestlocationid: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    processExpiredForecasts(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getOrderedQuantity(farmLocationId: number, farmInventoryLocation: string, uom: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ForecastClient implements IForecastClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    forecasts(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesters/{email}/forecasts";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForecasts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForecasts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForecasts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    paginatedForecasts(loggedInUsername: any | undefined, body: ForecastRequestModel | undefined): Observable<ForecastResponseModel> {
        let url_ = this.baseUrl + "/PaginatedForecasts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaginatedForecasts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaginatedForecasts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ForecastResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ForecastResponseModel>;
        }));
    }

    protected processPaginatedForecasts(response: HttpResponseBase): Observable<ForecastResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ForecastResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ForecastResponseModel>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    forecasts2(requestlocationid: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesters/forecasts/{requestlocationid}";
        if (requestlocationid === undefined || requestlocationid === null)
            throw new Error("The parameter 'requestlocationid' must be defined.");
        url_ = url_.replace("{requestlocationid}", encodeURIComponent("" + requestlocationid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForecasts2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForecasts2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForecasts2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getUsedQuantity(farmLocationId: number, farmInventoryLocation: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Request/GetUsedQuantity/{FarmLocationId}/{FarmInventoryLocation}";
        if (farmLocationId === undefined || farmLocationId === null)
            throw new Error("The parameter 'farmLocationId' must be defined.");
        url_ = url_.replace("{FarmLocationId}", encodeURIComponent("" + farmLocationId));
        if (farmInventoryLocation === undefined || farmInventoryLocation === null)
            throw new Error("The parameter 'farmInventoryLocation' must be defined.");
        url_ = url_.replace("{FarmInventoryLocation}", encodeURIComponent("" + farmInventoryLocation));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetUsedQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getAdvancedQuantity(farmLocationId: number, uom: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Request/GetAdvancedQuantity/{FarmLocationId}/{uom}";
        if (farmLocationId === undefined || farmLocationId === null)
            throw new Error("The parameter 'farmLocationId' must be defined.");
        url_ = url_.replace("{FarmLocationId}", encodeURIComponent("" + farmLocationId));
        if (uom === undefined || uom === null)
            throw new Error("The parameter 'uom' must be defined.");
        url_ = url_.replace("{uom}", encodeURIComponent("" + uom));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdvancedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdvancedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAdvancedQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    samplerequesthistory(requestlocationid: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/forecasts/samplerequesthistory/{requestlocationid}";
        if (requestlocationid === undefined || requestlocationid === null)
            throw new Error("The parameter 'requestlocationid' must be defined.");
        url_ = url_.replace("{requestlocationid}", encodeURIComponent("" + requestlocationid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSamplerequesthistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSamplerequesthistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSamplerequesthistory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    processExpiredForecasts(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Forecasts/ProcessExpiredForecasts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessExpiredForecasts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessExpiredForecasts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessExpiredForecasts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getOrderedQuantity(farmLocationId: number, farmInventoryLocation: string, uom: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/Request/GetOrderedQuantity/{FarmLocationId}/{FarmInventoryLocation}/{uom}";
        if (farmLocationId === undefined || farmLocationId === null)
            throw new Error("The parameter 'farmLocationId' must be defined.");
        url_ = url_.replace("{FarmLocationId}", encodeURIComponent("" + farmLocationId));
        if (farmInventoryLocation === undefined || farmInventoryLocation === null)
            throw new Error("The parameter 'farmInventoryLocation' must be defined.");
        url_ = url_.replace("{FarmInventoryLocation}", encodeURIComponent("" + farmInventoryLocation));
        if (uom === undefined || uom === null)
            throw new Error("The parameter 'uom' must be defined.");
        url_ = url_.replace("{uom}", encodeURIComponent("" + uom));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderedQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetOrderedQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IFunctionClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    functions(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class FunctionClient implements IFunctionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    functions(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/functions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFunctions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFunctions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFunctions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IIntegrationClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    token(target: string, loggedInUsername: any | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class IntegrationClient implements IIntegrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    token(target: string, loggedInUsername: any | undefined): Observable<string> {
        let url_ = this.baseUrl + "/integration/token/{target}";
        if (target === undefined || target === null)
            throw new Error("The parameter 'target' must be defined.");
        url_ = url_.replace("{target}", encodeURIComponent("" + target));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IInternalRecipientClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    internalGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    internalPOST(loggedInUsername: any | undefined, body: InternalRecipientModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    internalPUT(loggedInUsername: any | undefined, body: InternalRecipientModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    internalGET2(email: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    internalGET3(email: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class InternalRecipientClient implements IInternalRecipientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    internalGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/internal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInternalGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    internalPOST(loggedInUsername: any | undefined, body: InternalRecipientModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/internal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInternalPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    internalPUT(loggedInUsername: any | undefined, body: InternalRecipientModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/internal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInternalPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    internalGET2(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/{email}/recipients/internal";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInternalGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    internalGET3(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/{email}/internal";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInternalGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInternalGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInternalGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IMaterialApprovalClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getMaterialApproval(email: string, pageIndex: number, pageSize: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestApproval(loggedInUsername: any | undefined, body: ApproveRequestModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    returnForReview(loggedInUsername: any | undefined, body: ApproveRequestModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MaterialApprovalClient implements IMaterialApprovalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getMaterialApproval(email: string, pageIndex: number, pageSize: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/GetMaterialApproval/{email}/{pageIndex}/{pageSize}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined.");
        url_ = url_.replace("{pageIndex}", encodeURIComponent("" + pageIndex));
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined.");
        url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaterialApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetMaterialApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestApproval(loggedInUsername: any | undefined, body: ApproveRequestModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/RequestApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestApproval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    returnForReview(loggedInUsername: any | undefined, body: ApproveRequestModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/ReturnForReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnForReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnForReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReturnForReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IMenuClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    menus(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    menus2(email: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class MenuClient implements IMenuClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    menus(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/menus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMenus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMenus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMenus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    menus2(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/{email}/menus";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMenus2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMenus2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMenus2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IQuestionnaireClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestItemGET(name: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestItemPOST(requestNumber: string, loggedInUsername: any | undefined, body: SaveQuestionnaireModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class QuestionnaireClient implements IQuestionnaireClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestItemGET(name: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/questionnaiers/{name}/request-item/{requestNumber}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestItemGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestItemGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestItemGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestItemPOST(requestNumber: string, loggedInUsername: any | undefined, body: SaveQuestionnaireModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/save/{requestNumber}/request-item";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestItemPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestItemPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestItemPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRecipientClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    recipients(email: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RecipientClient implements IRecipientClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    recipients(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipients/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecipients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecipients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecipients(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRecipientAddressClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    recipientaddressDELETE(recipientId: number, addressId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    recipientaddressPUT(loggedInUsername: any | undefined, body: RecipientWithAddressModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RecipientAddressClient implements IRecipientAddressClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    recipientaddressDELETE(recipientId: number, addressId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipient/{recipientId}/address/{addressId}/recipientaddress";
        if (recipientId === undefined || recipientId === null)
            throw new Error("The parameter 'recipientId' must be defined.");
        url_ = url_.replace("{recipientId}", encodeURIComponent("" + recipientId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecipientaddressDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecipientaddressDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecipientaddressDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    recipientaddressPUT(loggedInUsername: any | undefined, body: RecipientWithAddressModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/recipientaddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecipientaddressPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecipientaddressPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecipientaddressPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRegionClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    regions(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RegionClient implements IRegionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    regions(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/regions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestsGET(requestType: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    creators(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestsGET2(userId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    filterP2PRequests(loggedInUsername: any | undefined, body: RequestModel[] | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestsPOST(loggedInUsername: any | undefined, body: RequestAdvanceSearchModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestsPOST2(requestType: string, loggedInUsername: any | undefined, body: CreateRequestModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    copy(requestType: string, requestNumber: string, loggedInUsername: any | undefined, body: CopyRequestModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestsDELETE(requestType: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    report(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestClient implements IRequestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestsGET(requestType: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/requests/{requestnumber}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestsGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    creators(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/creators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreators(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreators(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestsGET2(userId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/{userid}/requests";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestsGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    filterP2PRequests(loggedInUsername: any | undefined, body: RequestModel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/filterP2PRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilterP2PRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilterP2PRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFilterP2PRequests(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestsPOST(loggedInUsername: any | undefined, body: RequestAdvanceSearchModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/advance-search/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestsPOST2(requestType: string, loggedInUsername: any | undefined, body: CreateRequestModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requestType}/requests";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestsPOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestsPOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestsPOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    copy(requestType: string, requestNumber: string, loggedInUsername: any | undefined, body: CopyRequestModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/requests/{requestNumber}/copy";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestsDELETE(requestType: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/requests/{requestNumber}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    report(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/report";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequesterDelegatorClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesterdelegatorsGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requesterdelegatorsPOST(loggedInUsername: any | undefined, body: RequesterDelegatorModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requesterdelegatorsPUT(loggedInUsername: any | undefined, body: RequesterDelegatorModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesters(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesterdelegatorsDELETE(requesterdelegatorId: number, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequesterDelegatorClient implements IRequesterDelegatorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesterdelegatorsGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesterdelegators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesterdelegatorsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesterdelegatorsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesterdelegatorsGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requesterdelegatorsPOST(loggedInUsername: any | undefined, body: RequesterDelegatorModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesterdelegators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesterdelegatorsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesterdelegatorsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesterdelegatorsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requesterdelegatorsPUT(loggedInUsername: any | undefined, body: RequesterDelegatorModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesterdelegators";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesterdelegatorsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesterdelegatorsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesterdelegatorsPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesters(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/delegators/requesters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesterdelegatorsDELETE(requesterdelegatorId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesterdelegators/{requesterdelegatorid}";
        if (requesterdelegatorId === undefined || requesterdelegatorId === null)
            throw new Error("The parameter 'requesterdelegatorId' must be defined.");
        url_ = url_.replace("{requesterdelegatorId}", encodeURIComponent("" + requesterdelegatorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesterdelegatorsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesterdelegatorsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesterdelegatorsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequesterInformationClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesters2(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requester(requestId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requesterInformation(loggedInUsername: any | undefined, body: RequesterInformationModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequesterInformationClient implements IRequesterInformationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesters2(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/requesters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesters2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesters2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesters2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requester(requestId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/requester/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequester(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequester(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequester(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requesterInformation(loggedInUsername: any | undefined, body: RequesterInformationModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requester-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesterInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesterInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesterInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestItemClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestItemsGET(requestType: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param addToExisting (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestItemsPOST(requestType: string, requestnumber: string, addToExisting: boolean | undefined, loggedInUsername: any | undefined, body: RequestItemModel[] | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestItemsPOST2(requestType: string, requestitemid: string, loggedInUsername: any | undefined, body: RequestItemModel[] | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestItemsDELETE(requestType: string, requestitemId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    applyToAll(requestType: string, loggedInUsername: any | undefined, body: RequestItemPriorityModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    applyToAll2(requestType: string, loggedInUsername: any | undefined, body: RequestItemEupDocumentModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestItemClient implements IRequestItemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestItemsGET(requestType: string, requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requestType}/requests/{requestNumber}/request-items";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestItemsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestItemsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestItemsGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param addToExisting (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestItemsPOST(requestType: string, requestnumber: string, addToExisting: boolean | undefined, loggedInUsername: any | undefined, body: RequestItemModel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/requests/{requestnumber}/request-items?";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestnumber === undefined || requestnumber === null)
            throw new Error("The parameter 'requestnumber' must be defined.");
        url_ = url_.replace("{requestnumber}", encodeURIComponent("" + requestnumber));
        if (addToExisting === null)
            throw new Error("The parameter 'addToExisting' cannot be null.");
        else if (addToExisting !== undefined)
            url_ += "addToExisting=" + encodeURIComponent("" + addToExisting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestItemsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestItemsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestItemsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestItemsPOST2(requestType: string, requestitemid: string, loggedInUsername: any | undefined, body: RequestItemModel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/request-items/{requestitemid}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestitemid === undefined || requestitemid === null)
            throw new Error("The parameter 'requestitemid' must be defined.");
        url_ = url_.replace("{requestitemid}", encodeURIComponent("" + requestitemid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestItemsPOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestItemsPOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestItemsPOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requestItemsDELETE(requestType: string, requestitemId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/request-items/{requestitemid}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestitemId === undefined || requestitemId === null)
            throw new Error("The parameter 'requestitemId' must be defined.");
        url_ = url_.replace("{requestitemId}", encodeURIComponent("" + requestitemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestItemsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestItemsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestItemsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    applyToAll(requestType: string, loggedInUsername: any | undefined, body: RequestItemPriorityModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/request-items/priority/apply-to-all";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyToAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyToAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplyToAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    applyToAll2(requestType: string, loggedInUsername: any | undefined, body: RequestItemEupDocumentModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/request-items/eup-documents/apply-to-all";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyToAll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyToAll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processApplyToAll2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestItemAttachmentClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attachmentsGET(requestId: number, requestItemId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    documentTypes(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attachmentsGET2(requestId: number, requestItemId: number, requestItemAttachmentId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attachmentsDELETE(requestId: number, requestItemId: number, requestItemAttachmentId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attachmentsPOST(requestItemId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    comments(requestId: number, requestItemId: number, loggedInUsername: any | undefined, body: RequestItemAttachmentCommentModel[] | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    packedWithChoices(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestItemAttachmentClient implements IRequestItemAttachmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attachmentsGET(requestId: number, requestItemId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestId}/items/{requestItemId}/attachments";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        if (requestItemId === undefined || requestItemId === null)
            throw new Error("The parameter 'requestItemId' must be defined.");
        url_ = url_.replace("{requestItemId}", encodeURIComponent("" + requestItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachmentsGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    documentTypes(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/DocumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDocumentTypes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attachmentsGET2(requestId: number, requestItemId: number, requestItemAttachmentId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestId}/items/{requestItemId}/attachments/{requestItemAttachmentId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        if (requestItemId === undefined || requestItemId === null)
            throw new Error("The parameter 'requestItemId' must be defined.");
        url_ = url_.replace("{requestItemId}", encodeURIComponent("" + requestItemId));
        if (requestItemAttachmentId === undefined || requestItemAttachmentId === null)
            throw new Error("The parameter 'requestItemAttachmentId' must be defined.");
        url_ = url_.replace("{requestItemAttachmentId}", encodeURIComponent("" + requestItemAttachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachmentsGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attachmentsDELETE(requestId: number, requestItemId: number, requestItemAttachmentId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestId}/items/{requestItemId}/attachments/{requestItemAttachmentId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        if (requestItemId === undefined || requestItemId === null)
            throw new Error("The parameter 'requestItemId' must be defined.");
        url_ = url_.replace("{requestItemId}", encodeURIComponent("" + requestItemId));
        if (requestItemAttachmentId === undefined || requestItemAttachmentId === null)
            throw new Error("The parameter 'requestItemAttachmentId' must be defined.");
        url_ = url_.replace("{requestItemAttachmentId}", encodeURIComponent("" + requestItemAttachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachmentsDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attachmentsPOST(requestItemId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/items/{requestItemId}/attachments";
        if (requestItemId === undefined || requestItemId === null)
            throw new Error("The parameter 'requestItemId' must be defined.");
        url_ = url_.replace("{requestItemId}", encodeURIComponent("" + requestItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachmentsPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    comments(requestId: number, requestItemId: number, loggedInUsername: any | undefined, body: RequestItemAttachmentCommentModel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestId}/items/{requestItemId}/attachments/comments";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        if (requestItemId === undefined || requestItemId === null)
            throw new Error("The parameter 'requestItemId' must be defined.");
        url_ = url_.replace("{requestItemId}", encodeURIComponent("" + requestItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processComments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    packedWithChoices(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/PackedWithChoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPackedWithChoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPackedWithChoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPackedWithChoices(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestItemAttributeClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    postAttributes(loggedInUsername: any | undefined, body: RequestItemAttributeModel[] | undefined): Observable<void>;
    /**
     * @param cartItemId (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attributesList(cartItemId: number | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    deleteAttributes(cartItemId: number, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestItemAttributeClient implements IRequestItemAttributeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    postAttributes(loggedInUsername: any | undefined, body: RequestItemAttributeModel[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/attributes/postAttributes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAttributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostAttributes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param cartItemId (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    attributesList(cartItemId: number | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/attributes/attributesList?";
        if (cartItemId === null)
            throw new Error("The parameter 'cartItemId' cannot be null.");
        else if (cartItemId !== undefined)
            url_ += "CartItemId=" + encodeURIComponent("" + cartItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttributesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttributesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttributesList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    deleteAttributes(cartItemId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/attributes/{CartItemId}/deleteAttributes";
        if (cartItemId === undefined || cartItemId === null)
            throw new Error("The parameter 'cartItemId' must be defined.");
        url_ = url_.replace("{CartItemId}", encodeURIComponent("" + cartItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttributes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttributes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestNotificationClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    notificationUsersGET(requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    notificationUsersPOST(requestNumber: string, loggedInUsername: any | undefined, body: RequestNotificationModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    notificationUsersPUT(requestNumber: string, loggedInUsername: any | undefined, body: RequestNotificationModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    notificationUsersDELETE(requestnumber: string, requestNotificationId: number, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestNotificationClient implements IRequestNotificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    notificationUsersGET(requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestnumber}/notification-users";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUsersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUsersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotificationUsersGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    notificationUsersPOST(requestNumber: string, loggedInUsername: any | undefined, body: RequestNotificationModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestnumber}/notification-users";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUsersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUsersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotificationUsersPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    notificationUsersPUT(requestNumber: string, loggedInUsername: any | undefined, body: RequestNotificationModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestnumber}/notification-users";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUsersPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUsersPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotificationUsersPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    notificationUsersDELETE(requestnumber: string, requestNotificationId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requests/{requestnumber}/notification-users/{requestnotificationid}";
        if (requestnumber === undefined || requestnumber === null)
            throw new Error("The parameter 'requestnumber' must be defined.");
        url_ = url_.replace("{requestnumber}", encodeURIComponent("" + requestnumber));
        if (requestNotificationId === undefined || requestNotificationId === null)
            throw new Error("The parameter 'requestNotificationId' must be defined.");
        url_ = url_.replace("{requestNotificationId}", encodeURIComponent("" + requestNotificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotificationUsersDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotificationUsersDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotificationUsersDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestStatusClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestStatuses(requestType: string, requestNumber: string, loggedInUsername: any | undefined, body: RequestStatusModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    cancelRequest(requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    saveRequestComment(requestNumber: string, loggedInUsername: any | undefined, body: CommentModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getRequestComment(requestNumber: string, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    validateCancelRequest(alchemistOrderId: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestStatusClient implements IRequestStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    requestStatuses(requestType: string, requestNumber: string, loggedInUsername: any | undefined, body: RequestStatusModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requestType}/requests/{requestNumber}/request-statuses";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestStatuses(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    cancelRequest(requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/CancelRequest/{requestNumber}";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    saveRequestComment(requestNumber: string, loggedInUsername: any | undefined, body: CommentModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/SaveRequestComment/{requestNumber}";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveRequestComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveRequestComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveRequestComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    getRequestComment(requestNumber: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/GetRequestComment/{requestNumber}";
        if (requestNumber === undefined || requestNumber === null)
            throw new Error("The parameter 'requestNumber' must be defined.");
        url_ = url_.replace("{requestNumber}", encodeURIComponent("" + requestNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetRequestComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    validateCancelRequest(alchemistOrderId: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/ValidateCancelRequest/{alchemistOrderId}";
        if (alchemistOrderId === undefined || alchemistOrderId === null)
            throw new Error("The parameter 'alchemistOrderId' must be defined.");
        url_ = url_.replace("{alchemistOrderId}", encodeURIComponent("" + alchemistOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCancelRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCancelRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateCancelRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestStatusTypeClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requeststatustypes(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestStatusTypeClient implements IRequestStatusTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requeststatustypes(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requeststatustypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequeststatustypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequeststatustypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequeststatustypes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRequestTypeClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesttypes(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesttypes2(email: string, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RequestTypeClient implements IRequestTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesttypes(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesttypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesttypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesttypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesttypes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    requesttypes2(email: string, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/{email}/requesttypes";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequesttypes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequesttypes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequesttypes2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IRoleClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    roles(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient implements IRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    roles(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRoles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ISiteClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    sites(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class SiteClient implements ISiteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    sites(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/sites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSites(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ISynonymClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    synonyms(requestType: string, requestItemId: number, loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class SynonymClient implements ISynonymClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    synonyms(requestType: string, requestItemId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/request-types/{requesttype}/request-items/{requestitemid}/synonyms";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (requestItemId === undefined || requestItemId === null)
            throw new Error("The parameter 'requestItemId' must be defined.");
        url_ = url_.replace("{requestItemId}", encodeURIComponent("" + requestItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynonyms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynonyms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSynonyms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ISystemSettingsClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    systemsettingssGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    systemsettingssPUT(loggedInUsername: any | undefined, body: SystemSettingsModel | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class SystemSettingsClient implements ISystemSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    systemsettingssGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/systemsettingss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSystemsettingssGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSystemsettingssGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSystemsettingssGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    systemsettingssPUT(loggedInUsername: any | undefined, body: SystemSettingsModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/systemsettingss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSystemsettingssPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSystemsettingssPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSystemsettingssPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IUnitOfMeasureClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    unitofmeasuresGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    unitofmeasuresPOST(loggedInUsername: any | undefined, body: UnitOfMeasureModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    unitofmeasuresGET2(requestTypeId: number, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    unitofmeasuresGET3(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    unitofmeasuresPUT(loggedInUsername: any | undefined, body: UnitOfMeasureModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    map(requestTypeId: number, loggedInUsername: any | undefined, body: number[] | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class UnitOfMeasureClient implements IUnitOfMeasureClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    unitofmeasuresGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/unitofmeasures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitofmeasuresGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitofmeasuresGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnitofmeasuresGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    unitofmeasuresPOST(loggedInUsername: any | undefined, body: UnitOfMeasureModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/unitofmeasures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitofmeasuresPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitofmeasuresPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnitofmeasuresPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    unitofmeasuresGET2(requestTypeId: number, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesttype/{requesttypeid}/unitofmeasures";
        if (requestTypeId === undefined || requestTypeId === null)
            throw new Error("The parameter 'requestTypeId' must be defined.");
        url_ = url_.replace("{requestTypeId}", encodeURIComponent("" + requestTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitofmeasuresGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitofmeasuresGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnitofmeasuresGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    unitofmeasuresGET3(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesttypes/unitofmeasures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitofmeasuresGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitofmeasuresGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnitofmeasuresGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    unitofmeasuresPUT(loggedInUsername: any | undefined, body: UnitOfMeasureModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesttypes/unitofmeasures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnitofmeasuresPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnitofmeasuresPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnitofmeasuresPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    map(requestTypeId: number, loggedInUsername: any | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/requesttypes/{requesttypeId}/unitofmeasures/map";
        if (requestTypeId === undefined || requestTypeId === null)
            throw new Error("The parameter 'requestTypeId' must be defined.");
        url_ = url_.replace("{requestTypeId}", encodeURIComponent("" + requestTypeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface IUserClient {
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    usersGET(loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    usersPOST(loggedInUsername: any | undefined, body: UserModel | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    usersPUT(loggedInUsername: any | undefined, body: UserModel | undefined): Observable<void>;
    /**
     * @param userId (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    usersDELETE(userId: number | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param email (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    email(email: string | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param searchString (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    search3(searchString: string | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param emailId (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    updateMaterialApprover(emailId: string | undefined, loggedInUsername: any | undefined): Observable<void>;
    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    supervisors(loggedInUsername: any | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    usersGET(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUsersGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    usersPOST(loggedInUsername: any | undefined, body: UserModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUsersPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @param body (optional) 
     * @return Success
     */
    usersPUT(loggedInUsername: any | undefined, body: UserModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUsersPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    usersDELETE(userId: number | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsersDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsersDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUsersDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param email (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    email(email: string | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/email?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    search3(searchString: string | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/search?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSearch3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param emailId (optional) 
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    updateMaterialApprover(emailId: string | undefined, loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/UpdateMaterialApprover?";
        if (emailId === null)
            throw new Error("The parameter 'emailId' cannot be null.");
        else if (emailId !== undefined)
            url_ += "emailId=" + encodeURIComponent("" + emailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMaterialApprover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialApprover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMaterialApprover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param loggedInUsername (optional) Email as loggedInUsername
     * @return Success
     */
    supervisors(loggedInUsername: any | undefined): Observable<void> {
        let url_ = this.baseUrl + "/users/supervisors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "loggedInUsername": loggedInUsername !== undefined && loggedInUsername !== null ? "" + loggedInUsername : "",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupervisors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupervisors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSupervisors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AddressModel implements IAddressModel {
    addressId?: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    countryId?: number;
    officePhone1?: string | undefined;
    officePhone2?: string | undefined;
    homePhone1?: string | undefined;
    homePhone2?: string | undefined;
    mobile?: string | undefined;
    postalCode?: string | undefined;
    isActive?: boolean;
    isActiveDirectoryAddress?: boolean;
    country?: string | undefined;
    isDeletedAddress?: boolean;
    parentAddressId?: number | undefined;
    isParentUpdated?: boolean;
    isParentDeleted?: boolean;
    isDefaultAddress?: boolean;
    recipientId?: number;
    orgName?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedAt?: Date;
    isIndyAligned?: boolean | undefined;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.countryId = _data["countryId"];
            this.officePhone1 = _data["officePhone1"];
            this.officePhone2 = _data["officePhone2"];
            this.homePhone1 = _data["homePhone1"];
            this.homePhone2 = _data["homePhone2"];
            this.mobile = _data["mobile"];
            this.postalCode = _data["postalCode"];
            this.isActive = _data["isActive"];
            this.isActiveDirectoryAddress = _data["isActiveDirectoryAddress"];
            this.country = _data["country"];
            this.isDeletedAddress = _data["isDeletedAddress"];
            this.parentAddressId = _data["parentAddressId"];
            this.isParentUpdated = _data["isParentUpdated"];
            this.isParentDeleted = _data["isParentDeleted"];
            this.isDefaultAddress = _data["isDefaultAddress"];
            this.recipientId = _data["recipientId"];
            this.orgName = _data["orgName"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : <any>undefined;
            this.isIndyAligned = _data["isIndyAligned"];
        }
    }

    static fromJS(data: any, _mappings?: any): AddressModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AddressModel>(data, _mappings, AddressModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["city"] = this.city;
        data["state"] = this.state;
        data["countryId"] = this.countryId;
        data["officePhone1"] = this.officePhone1;
        data["officePhone2"] = this.officePhone2;
        data["homePhone1"] = this.homePhone1;
        data["homePhone2"] = this.homePhone2;
        data["mobile"] = this.mobile;
        data["postalCode"] = this.postalCode;
        data["isActive"] = this.isActive;
        data["isActiveDirectoryAddress"] = this.isActiveDirectoryAddress;
        data["country"] = this.country;
        data["isDeletedAddress"] = this.isDeletedAddress;
        data["parentAddressId"] = this.parentAddressId;
        data["isParentUpdated"] = this.isParentUpdated;
        data["isParentDeleted"] = this.isParentDeleted;
        data["isDefaultAddress"] = this.isDefaultAddress;
        data["recipientId"] = this.recipientId;
        data["orgName"] = this.orgName;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : <any>undefined;
        data["isIndyAligned"] = this.isIndyAligned;
        return data;
    }
}

export interface IAddressModel {
    addressId?: number;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    countryId?: number;
    officePhone1?: string | undefined;
    officePhone2?: string | undefined;
    homePhone1?: string | undefined;
    homePhone2?: string | undefined;
    mobile?: string | undefined;
    postalCode?: string | undefined;
    isActive?: boolean;
    isActiveDirectoryAddress?: boolean;
    country?: string | undefined;
    isDeletedAddress?: boolean;
    parentAddressId?: number | undefined;
    isParentUpdated?: boolean;
    isParentDeleted?: boolean;
    isDefaultAddress?: boolean;
    recipientId?: number;
    orgName?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedAt?: Date;
    isIndyAligned?: boolean | undefined;
}

export class ApproveRequestModel implements IApproveRequestModel {
    requestItemId?: number;
    isApproved?: boolean;
    approvedByUserId?: number;
    comment?: string | undefined;
    approvalTimeStamp?: Date;
    commentType?: string | undefined;

    constructor(data?: IApproveRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestItemId = _data["requestItemId"];
            this.isApproved = _data["isApproved"];
            this.approvedByUserId = _data["approvedByUserId"];
            this.comment = _data["comment"];
            this.approvalTimeStamp = _data["approvalTimeStamp"] ? new Date(_data["approvalTimeStamp"].toString()) : <any>undefined;
            this.commentType = _data["commentType"];
        }
    }

    static fromJS(data: any, _mappings?: any): ApproveRequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ApproveRequestModel>(data, _mappings, ApproveRequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestItemId"] = this.requestItemId;
        data["isApproved"] = this.isApproved;
        data["approvedByUserId"] = this.approvedByUserId;
        data["comment"] = this.comment;
        data["approvalTimeStamp"] = this.approvalTimeStamp ? this.approvalTimeStamp.toISOString() : <any>undefined;
        data["commentType"] = this.commentType;
        return data;
    }
}

export interface IApproveRequestModel {
    requestItemId?: number;
    isApproved?: boolean;
    approvedByUserId?: number;
    comment?: string | undefined;
    approvalTimeStamp?: Date;
    commentType?: string | undefined;
}

export class CartItemModel implements ICartItemModel {
    cartId?: number;
    cartItemId?: number;
    materialName?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    uom?: string | undefined;
    lotNumber?: string | undefined;
    recertificationDate?: Date | undefined;
    availableAmount?: number | undefined;
    tsnNumber?: string | undefined;
    createdDate?: Date;
    materialId?: string | undefined;
    requestTypeId?: number;
    cartRequestTypeId?: number | undefined;
    requestTypeName?: string | undefined;
    requestLocationId?: number;
    forecastRequesterId?: number | undefined;
    forecastId?: number | undefined;
    farmInventoryStatus?: string | undefined;
    farmInventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    materialSearchType?: string | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    isBioFormulation?: boolean;
    requestItemAttributes?: RequestItemAttributeModel[] | undefined;

    constructor(data?: ICartItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.cartId = _data["cartId"];
            this.cartItemId = _data["cartItemId"];
            this.materialName = _data["materialName"];
            this.repoName = _data["repoName"];
            this.synonyms = _data["synonyms"];
            this.uom = _data["uom"];
            this.lotNumber = _data["lotNumber"];
            this.recertificationDate = _data["recertificationDate"] ? new Date(_data["recertificationDate"].toString()) : <any>undefined;
            this.availableAmount = _data["availableAmount"];
            this.tsnNumber = _data["tsnNumber"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.materialId = _data["materialId"];
            this.requestTypeId = _data["requestTypeId"];
            this.cartRequestTypeId = _data["cartRequestTypeId"];
            this.requestTypeName = _data["requestTypeName"];
            this.requestLocationId = _data["requestLocationId"];
            this.forecastRequesterId = _data["forecastRequesterId"];
            this.forecastId = _data["forecastId"];
            this.farmInventoryStatus = _data["farmInventoryStatus"];
            this.farmInventoryLocation = _data["farmInventoryLocation"];
            this.warehouseId = _data["warehouseId"];
            this.materialSearchType = _data["materialSearchType"];
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.isBioFormulation = _data["isBioFormulation"];
            if (Array.isArray(_data["requestItemAttributes"])) {
                this.requestItemAttributes = [] as any;
                for (let item of _data["requestItemAttributes"])
                    this.requestItemAttributes.push(RequestItemAttributeModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CartItemModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CartItemModel>(data, _mappings, CartItemModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartId"] = this.cartId;
        data["cartItemId"] = this.cartItemId;
        data["materialName"] = this.materialName;
        data["repoName"] = this.repoName;
        data["synonyms"] = this.synonyms;
        data["uom"] = this.uom;
        data["lotNumber"] = this.lotNumber;
        data["recertificationDate"] = this.recertificationDate ? this.recertificationDate.toISOString() : <any>undefined;
        data["availableAmount"] = this.availableAmount;
        data["tsnNumber"] = this.tsnNumber;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["materialId"] = this.materialId;
        data["requestTypeId"] = this.requestTypeId;
        data["cartRequestTypeId"] = this.cartRequestTypeId;
        data["requestTypeName"] = this.requestTypeName;
        data["requestLocationId"] = this.requestLocationId;
        data["forecastRequesterId"] = this.forecastRequesterId;
        data["forecastId"] = this.forecastId;
        data["farmInventoryStatus"] = this.farmInventoryStatus;
        data["farmInventoryLocation"] = this.farmInventoryLocation;
        data["warehouseId"] = this.warehouseId;
        data["materialSearchType"] = this.materialSearchType;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["isBioFormulation"] = this.isBioFormulation;
        if (Array.isArray(this.requestItemAttributes)) {
            data["requestItemAttributes"] = [];
            for (let item of this.requestItemAttributes)
                data["requestItemAttributes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICartItemModel {
    cartId?: number;
    cartItemId?: number;
    materialName?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    uom?: string | undefined;
    lotNumber?: string | undefined;
    recertificationDate?: Date | undefined;
    availableAmount?: number | undefined;
    tsnNumber?: string | undefined;
    createdDate?: Date;
    materialId?: string | undefined;
    requestTypeId?: number;
    cartRequestTypeId?: number | undefined;
    requestTypeName?: string | undefined;
    requestLocationId?: number;
    forecastRequesterId?: number | undefined;
    forecastId?: number | undefined;
    farmInventoryStatus?: string | undefined;
    farmInventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    materialSearchType?: string | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    isBioFormulation?: boolean;
    requestItemAttributes?: RequestItemAttributeModel[] | undefined;
}

export class CommentModel implements ICommentModel {
    id?: number;
    comment1?: string | undefined;
    enteredByUserId?: number;
    enteredAt?: Date;
    commentType?: string | undefined;

    constructor(data?: ICommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment1 = _data["comment1"];
            this.enteredByUserId = _data["enteredByUserId"];
            this.enteredAt = _data["enteredAt"] ? new Date(_data["enteredAt"].toString()) : <any>undefined;
            this.commentType = _data["commentType"];
        }
    }

    static fromJS(data: any, _mappings?: any): CommentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CommentModel>(data, _mappings, CommentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment1"] = this.comment1;
        data["enteredByUserId"] = this.enteredByUserId;
        data["enteredAt"] = this.enteredAt ? this.enteredAt.toISOString() : <any>undefined;
        data["commentType"] = this.commentType;
        return data;
    }
}

export interface ICommentModel {
    id?: number;
    comment1?: string | undefined;
    enteredByUserId?: number;
    enteredAt?: Date;
    commentType?: string | undefined;
}

export class CopyRequestModel implements ICopyRequestModel {
    requesterDetails?: boolean;
    recipientDetails?: boolean;
    samples?: boolean;
    containers?: boolean;
    attachments?: boolean;
    numberOfCopies?: number;

    constructor(data?: ICopyRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requesterDetails = _data["requesterDetails"];
            this.recipientDetails = _data["recipientDetails"];
            this.samples = _data["samples"];
            this.containers = _data["containers"];
            this.attachments = _data["attachments"];
            this.numberOfCopies = _data["numberOfCopies"];
        }
    }

    static fromJS(data: any, _mappings?: any): CopyRequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CopyRequestModel>(data, _mappings, CopyRequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requesterDetails"] = this.requesterDetails;
        data["recipientDetails"] = this.recipientDetails;
        data["samples"] = this.samples;
        data["containers"] = this.containers;
        data["attachments"] = this.attachments;
        data["numberOfCopies"] = this.numberOfCopies;
        return data;
    }
}

export interface ICopyRequestModel {
    requesterDetails?: boolean;
    recipientDetails?: boolean;
    samples?: boolean;
    containers?: boolean;
    attachments?: boolean;
    numberOfCopies?: number;
}

export class CreateRequestModel implements ICreateRequestModel {
    cartItemList?: CartItemModel[] | undefined;

    constructor(data?: ICreateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["cartItemList"])) {
                this.cartItemList = [] as any;
                for (let item of _data["cartItemList"])
                    this.cartItemList.push(CartItemModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CreateRequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CreateRequestModel>(data, _mappings, CreateRequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cartItemList)) {
            data["cartItemList"] = [];
            for (let item of this.cartItemList)
                data["cartItemList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateRequestModel {
    cartItemList?: CartItemModel[] | undefined;
}

export class DataTypeModel implements IDataTypeModel {
    dataTypeId?: number;
    name?: string | undefined;
    systemDataType?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date;
    modifiedBy?: number;

    constructor(data?: IDataTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.dataTypeId = _data["dataTypeId"];
            this.name = _data["name"];
            this.systemDataType = _data["systemDataType"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any, _mappings?: any): DataTypeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DataTypeModel>(data, _mappings, DataTypeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataTypeId"] = this.dataTypeId;
        data["name"] = this.name;
        data["systemDataType"] = this.systemDataType;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IDataTypeModel {
    dataTypeId?: number;
    name?: string | undefined;
    systemDataType?: string | undefined;
    description?: string | undefined;
    isActive?: boolean;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date;
    modifiedBy?: number;
}

export class EmailMessageLogModel implements IEmailMessageLogModel {
    emailMessageLogId?: number;
    requestId?: number;
    toRecipients?: string | undefined;
    ccRecipients?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isSent?: boolean;
    createdDate?: Date;
    createdBy?: number;
    displayName?: string | undefined;

    constructor(data?: IEmailMessageLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.emailMessageLogId = _data["emailMessageLogId"];
            this.requestId = _data["requestId"];
            this.toRecipients = _data["toRecipients"];
            this.ccRecipients = _data["ccRecipients"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.isSent = _data["isSent"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any, _mappings?: any): EmailMessageLogModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<EmailMessageLogModel>(data, _mappings, EmailMessageLogModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailMessageLogId"] = this.emailMessageLogId;
        data["requestId"] = this.requestId;
        data["toRecipients"] = this.toRecipients;
        data["ccRecipients"] = this.ccRecipients;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["isSent"] = this.isSent;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IEmailMessageLogModel {
    emailMessageLogId?: number;
    requestId?: number;
    toRecipients?: string | undefined;
    ccRecipients?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    isSent?: boolean;
    createdDate?: Date;
    createdBy?: number;
    displayName?: string | undefined;
}

export class ExceptionLogModel implements IExceptionLogModel {
    exceptionLogId?: number;
    exceptionText?: string | undefined;
    customMessage?: string | undefined;
    createdDate?: Date;

    constructor(data?: IExceptionLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.exceptionLogId = _data["exceptionLogId"];
            this.exceptionText = _data["exceptionText"];
            this.customMessage = _data["customMessage"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ExceptionLogModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExceptionLogModel>(data, _mappings, ExceptionLogModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionLogId"] = this.exceptionLogId;
        data["exceptionText"] = this.exceptionText;
        data["customMessage"] = this.customMessage;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExceptionLogModel {
    exceptionLogId?: number;
    exceptionText?: string | undefined;
    customMessage?: string | undefined;
    createdDate?: Date;
}

export class ExternalRecipientModel implements IExternalRecipientModel {
    recipientId?: number;
    email?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    contactNumber?: string | undefined;
    isExternalRecipient?: boolean;
    externalRecipientId?: number;
    fullName?: string | undefined;
    displayName?: string | undefined;
    legalName?: string | undefined;
    internalContactName?: string | undefined;
    internalContactEmail?: string | undefined;
    countryId?: number;
    country?: string | undefined;

    constructor(data?: IExternalRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.recipientId = _data["recipientId"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.contactNumber = _data["contactNumber"];
            this.isExternalRecipient = _data["isExternalRecipient"];
            this.externalRecipientId = _data["externalRecipientId"];
            this.fullName = _data["fullName"];
            this.displayName = _data["displayName"];
            this.legalName = _data["legalName"];
            this.internalContactName = _data["internalContactName"];
            this.internalContactEmail = _data["internalContactEmail"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any, _mappings?: any): ExternalRecipientModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ExternalRecipientModel>(data, _mappings, ExternalRecipientModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientId"] = this.recipientId;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["contactNumber"] = this.contactNumber;
        data["isExternalRecipient"] = this.isExternalRecipient;
        data["externalRecipientId"] = this.externalRecipientId;
        data["fullName"] = this.fullName;
        data["displayName"] = this.displayName;
        data["legalName"] = this.legalName;
        data["internalContactName"] = this.internalContactName;
        data["internalContactEmail"] = this.internalContactEmail;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }
}

export interface IExternalRecipientModel {
    recipientId?: number;
    email?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    contactNumber?: string | undefined;
    isExternalRecipient?: boolean;
    externalRecipientId?: number;
    fullName?: string | undefined;
    displayName?: string | undefined;
    legalName?: string | undefined;
    internalContactName?: string | undefined;
    internalContactEmail?: string | undefined;
    countryId?: number;
    country?: string | undefined;
}

export class FavoriteModel implements IFavoriteModel {
    favoriteId?: number;
    userId?: number;
    requestId?: number;

    constructor(data?: IFavoriteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.favoriteId = _data["favoriteId"];
            this.userId = _data["userId"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any, _mappings?: any): FavoriteModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FavoriteModel>(data, _mappings, FavoriteModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favoriteId"] = this.favoriteId;
        data["userId"] = this.userId;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IFavoriteModel {
    favoriteId?: number;
    userId?: number;
    requestId?: number;
}

export class ForecastModel implements IForecastModel {
    requestLocationId?: number;
    forecastId?: number;
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    lotNumber?: string | undefined;
    inventoryOrderState?: string | undefined;
    inventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    forecasters?: string | undefined;
    requesters?: string | undefined;
    forecastEndDate?: Date | undefined;
    hasExpired?: boolean;
    country?: string | undefined;
    countryCode?: string | undefined;
    isRegion?: boolean;
    isReachCompliant?: boolean | undefined;
    amountForecasted?: number;
    uom?: string | undefined;
    amountRemaining?: number;
    requestTypeId?: number;
    requestTypeName?: string | undefined;
    sampleRequestHistory?: string | undefined;
    isAdded?: boolean;
    materialApprover?: string | undefined;
    programNumber?: string | undefined;

    constructor(data?: IForecastModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestLocationId = _data["requestLocationId"];
            this.forecastId = _data["forecastId"];
            this.materialName = _data["materialName"];
            this.materialId = _data["materialId"];
            this.repoName = _data["repoName"];
            this.synonyms = _data["synonyms"];
            this.lotNumber = _data["lotNumber"];
            this.inventoryOrderState = _data["inventoryOrderState"];
            this.inventoryLocation = _data["inventoryLocation"];
            this.warehouseId = _data["warehouseId"];
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.forecasters = _data["forecasters"];
            this.requesters = _data["requesters"];
            this.forecastEndDate = _data["forecastEndDate"] ? new Date(_data["forecastEndDate"].toString()) : <any>undefined;
            this.hasExpired = _data["hasExpired"];
            this.country = _data["country"];
            this.countryCode = _data["countryCode"];
            this.isRegion = _data["isRegion"];
            this.isReachCompliant = _data["isReachCompliant"];
            this.amountForecasted = _data["amountForecasted"];
            this.uom = _data["uom"];
            this.amountRemaining = _data["amountRemaining"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestTypeName = _data["requestTypeName"];
            this.sampleRequestHistory = _data["sampleRequestHistory"];
            this.isAdded = _data["isAdded"];
            this.materialApprover = _data["materialApprover"];
            this.programNumber = _data["programNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastModel>(data, _mappings, ForecastModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestLocationId"] = this.requestLocationId;
        data["forecastId"] = this.forecastId;
        data["materialName"] = this.materialName;
        data["materialId"] = this.materialId;
        data["repoName"] = this.repoName;
        data["synonyms"] = this.synonyms;
        data["lotNumber"] = this.lotNumber;
        data["inventoryOrderState"] = this.inventoryOrderState;
        data["inventoryLocation"] = this.inventoryLocation;
        data["warehouseId"] = this.warehouseId;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["forecasters"] = this.forecasters;
        data["requesters"] = this.requesters;
        data["forecastEndDate"] = this.forecastEndDate ? this.forecastEndDate.toISOString() : <any>undefined;
        data["hasExpired"] = this.hasExpired;
        data["country"] = this.country;
        data["countryCode"] = this.countryCode;
        data["isRegion"] = this.isRegion;
        data["isReachCompliant"] = this.isReachCompliant;
        data["amountForecasted"] = this.amountForecasted;
        data["uom"] = this.uom;
        data["amountRemaining"] = this.amountRemaining;
        data["requestTypeId"] = this.requestTypeId;
        data["requestTypeName"] = this.requestTypeName;
        data["sampleRequestHistory"] = this.sampleRequestHistory;
        data["isAdded"] = this.isAdded;
        data["materialApprover"] = this.materialApprover;
        data["programNumber"] = this.programNumber;
        return data;
    }
}

export interface IForecastModel {
    requestLocationId?: number;
    forecastId?: number;
    materialName?: string | undefined;
    materialId?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    lotNumber?: string | undefined;
    inventoryOrderState?: string | undefined;
    inventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    forecasters?: string | undefined;
    requesters?: string | undefined;
    forecastEndDate?: Date | undefined;
    hasExpired?: boolean;
    country?: string | undefined;
    countryCode?: string | undefined;
    isRegion?: boolean;
    isReachCompliant?: boolean | undefined;
    amountForecasted?: number;
    uom?: string | undefined;
    amountRemaining?: number;
    requestTypeId?: number;
    requestTypeName?: string | undefined;
    sampleRequestHistory?: string | undefined;
    isAdded?: boolean;
    materialApprover?: string | undefined;
    programNumber?: string | undefined;
}

export class ForecastRequestModel implements IForecastRequestModel {
    filterValue?: string | undefined;
    requesterEmail?: string | undefined;
    delegatorEmail?: string | undefined;
    forecasterEmail?: string | undefined;
    sortOrder?: string | undefined;
    isASC?: boolean;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IForecastRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.filterValue = _data["filterValue"];
            this.requesterEmail = _data["requesterEmail"];
            this.delegatorEmail = _data["delegatorEmail"];
            this.forecasterEmail = _data["forecasterEmail"];
            this.sortOrder = _data["sortOrder"];
            this.isASC = _data["isASC"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastRequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastRequestModel>(data, _mappings, ForecastRequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterValue"] = this.filterValue;
        data["requesterEmail"] = this.requesterEmail;
        data["delegatorEmail"] = this.delegatorEmail;
        data["forecasterEmail"] = this.forecasterEmail;
        data["sortOrder"] = this.sortOrder;
        data["isASC"] = this.isASC;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IForecastRequestModel {
    filterValue?: string | undefined;
    requesterEmail?: string | undefined;
    delegatorEmail?: string | undefined;
    forecasterEmail?: string | undefined;
    sortOrder?: string | undefined;
    isASC?: boolean;
    pageIndex?: number;
    pageSize?: number;
}

export class ForecastResponseModel implements IForecastResponseModel {
    requesterEmail?: string | undefined;
    delegatorEmail?: string | undefined;
    forecasterEmail?: string | undefined;
    filterValue?: string | undefined;
    forecasts?: ForecastModel[] | undefined;
    sortOrder?: string | undefined;
    isASC?: boolean;
    pageIndex?: number;
    pageCount?: number;
    totalCount?: number;

    constructor(data?: IForecastResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requesterEmail = _data["requesterEmail"];
            this.delegatorEmail = _data["delegatorEmail"];
            this.forecasterEmail = _data["forecasterEmail"];
            this.filterValue = _data["filterValue"];
            if (Array.isArray(_data["forecasts"])) {
                this.forecasts = [] as any;
                for (let item of _data["forecasts"])
                    this.forecasts.push(ForecastModel.fromJS(item, _mappings));
            }
            this.sortOrder = _data["sortOrder"];
            this.isASC = _data["isASC"];
            this.pageIndex = _data["pageIndex"];
            this.pageCount = _data["pageCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any, _mappings?: any): ForecastResponseModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ForecastResponseModel>(data, _mappings, ForecastResponseModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requesterEmail"] = this.requesterEmail;
        data["delegatorEmail"] = this.delegatorEmail;
        data["forecasterEmail"] = this.forecasterEmail;
        data["filterValue"] = this.filterValue;
        if (Array.isArray(this.forecasts)) {
            data["forecasts"] = [];
            for (let item of this.forecasts)
                data["forecasts"].push(item.toJSON());
        }
        data["sortOrder"] = this.sortOrder;
        data["isASC"] = this.isASC;
        data["pageIndex"] = this.pageIndex;
        data["pageCount"] = this.pageCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IForecastResponseModel {
    requesterEmail?: string | undefined;
    delegatorEmail?: string | undefined;
    forecasterEmail?: string | undefined;
    filterValue?: string | undefined;
    forecasts?: ForecastModel[] | undefined;
    sortOrder?: string | undefined;
    isASC?: boolean;
    pageIndex?: number;
    pageCount?: number;
    totalCount?: number;
}

export class InternalRecipientModel implements IInternalRecipientModel {
    recipientId?: number;
    email?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    contactNumber?: string | undefined;
    isExternalRecipient?: boolean;
    internalRecipientId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    functionId?: number;
    function?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
    countryId?: number;
    country?: string | undefined;

    constructor(data?: IInternalRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.recipientId = _data["recipientId"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.contactNumber = _data["contactNumber"];
            this.isExternalRecipient = _data["isExternalRecipient"];
            this.internalRecipientId = _data["internalRecipientId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.displayName = _data["displayName"];
            this.functionId = _data["functionId"];
            this.function = _data["function"];
            this.supervisorName = _data["supervisorName"];
            this.supervisorEmail = _data["supervisorEmail"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any, _mappings?: any): InternalRecipientModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<InternalRecipientModel>(data, _mappings, InternalRecipientModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientId"] = this.recipientId;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["contactNumber"] = this.contactNumber;
        data["isExternalRecipient"] = this.isExternalRecipient;
        data["internalRecipientId"] = this.internalRecipientId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["displayName"] = this.displayName;
        data["functionId"] = this.functionId;
        data["function"] = this.function;
        data["supervisorName"] = this.supervisorName;
        data["supervisorEmail"] = this.supervisorEmail;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }
}

export interface IInternalRecipientModel {
    recipientId?: number;
    email?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    contactNumber?: string | undefined;
    isExternalRecipient?: boolean;
    internalRecipientId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    functionId?: number;
    function?: string | undefined;
    supervisorName?: string | undefined;
    supervisorEmail?: string | undefined;
    countryId?: number;
    country?: string | undefined;
}

export class OrderDetailMessage implements IOrderDetailMessage {
    orderID?: string;
    requestID?: number;
    requestNumber?: string | undefined;
    orderStatus?: string | undefined;
    orderStatusDetails?: string | undefined;
    isOnHold?: boolean;
    holdDetails?: string | undefined;
    sequenceNumber?: number | undefined;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    useReservation?: boolean;
    items?: OrderItemMessage[] | undefined;
    shipments?: OrderShipmentMessage[] | undefined;

    constructor(data?: IOrderDetailMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.orderID = _data["orderID"];
            this.requestID = _data["requestID"];
            this.requestNumber = _data["requestNumber"];
            this.orderStatus = _data["orderStatus"];
            this.orderStatusDetails = _data["orderStatusDetails"];
            this.isOnHold = _data["isOnHold"];
            this.holdDetails = _data["holdDetails"];
            this.sequenceNumber = _data["sequenceNumber"];
            this.coordinatorName = _data["coordinatorName"];
            this.coordinatorEmail = _data["coordinatorEmail"];
            this.useReservation = _data["useReservation"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderItemMessage.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments.push(OrderShipmentMessage.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): OrderDetailMessage | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderDetailMessage>(data, _mappings, OrderDetailMessage);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["requestID"] = this.requestID;
        data["requestNumber"] = this.requestNumber;
        data["orderStatus"] = this.orderStatus;
        data["orderStatusDetails"] = this.orderStatusDetails;
        data["isOnHold"] = this.isOnHold;
        data["holdDetails"] = this.holdDetails;
        data["sequenceNumber"] = this.sequenceNumber;
        data["coordinatorName"] = this.coordinatorName;
        data["coordinatorEmail"] = this.coordinatorEmail;
        data["useReservation"] = this.useReservation;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderDetailMessage {
    orderID?: string;
    requestID?: number;
    requestNumber?: string | undefined;
    orderStatus?: string | undefined;
    orderStatusDetails?: string | undefined;
    isOnHold?: boolean;
    holdDetails?: string | undefined;
    sequenceNumber?: number | undefined;
    coordinatorName?: string | undefined;
    coordinatorEmail?: string | undefined;
    useReservation?: boolean;
    items?: OrderItemMessage[] | undefined;
    shipments?: OrderShipmentMessage[] | undefined;
}

export class OrderItemMessage implements IOrderItemMessage {
    sourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    requestItemID?: number;
    inventoryCatalogID?: number | undefined;
    lotNumber?: string | undefined;
    amount?: number;
    unitOfMeasure?: string | undefined;

    constructor(data?: IOrderItemMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.sourceSystem = _data["sourceSystem"];
            this.productIdentifier = _data["productIdentifier"];
            this.requestItemID = _data["requestItemID"];
            this.inventoryCatalogID = _data["inventoryCatalogID"];
            this.lotNumber = _data["lotNumber"];
            this.amount = _data["amount"];
            this.unitOfMeasure = _data["unitOfMeasure"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrderItemMessage | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderItemMessage>(data, _mappings, OrderItemMessage);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceSystem"] = this.sourceSystem;
        data["productIdentifier"] = this.productIdentifier;
        data["requestItemID"] = this.requestItemID;
        data["inventoryCatalogID"] = this.inventoryCatalogID;
        data["lotNumber"] = this.lotNumber;
        data["amount"] = this.amount;
        data["unitOfMeasure"] = this.unitOfMeasure;
        return data;
    }
}

export interface IOrderItemMessage {
    sourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    requestItemID?: number;
    inventoryCatalogID?: number | undefined;
    lotNumber?: string | undefined;
    amount?: number;
    unitOfMeasure?: string | undefined;
}

export class OrderShipmentMessage implements IOrderShipmentMessage {
    shipperName?: string | undefined;
    trackingNumber?: string | undefined;

    constructor(data?: IOrderShipmentMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.shipperName = _data["shipperName"];
            this.trackingNumber = _data["trackingNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): OrderShipmentMessage | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<OrderShipmentMessage>(data, _mappings, OrderShipmentMessage);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipperName"] = this.shipperName;
        data["trackingNumber"] = this.trackingNumber;
        return data;
    }
}

export interface IOrderShipmentMessage {
    shipperName?: string | undefined;
    trackingNumber?: string | undefined;
}

export class RecipientModel implements IRecipientModel {
    recipientId?: number;
    email?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    contactNumber?: string | undefined;
    isExternalRecipient?: boolean;

    constructor(data?: IRecipientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.recipientId = _data["recipientId"];
            this.email = _data["email"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.contactNumber = _data["contactNumber"];
            this.isExternalRecipient = _data["isExternalRecipient"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecipientModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecipientModel>(data, _mappings, RecipientModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientId"] = this.recipientId;
        data["email"] = this.email;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["contactNumber"] = this.contactNumber;
        data["isExternalRecipient"] = this.isExternalRecipient;
        return data;
    }
}

export interface IRecipientModel {
    recipientId?: number;
    email?: string | undefined;
    isActive?: boolean;
    isDeleted?: boolean;
    contactNumber?: string | undefined;
    isExternalRecipient?: boolean;
}

export enum RecipientType {
    _0 = 0,
    _1 = 1,
}

export class RecipientWithAddressModel implements IRecipientWithAddressModel {
    recipient?: RecipientModel;
    address?: AddressModel;
    recipientId?: number;
    addressId?: number;
    isDefaultAddress?: boolean;

    constructor(data?: IRecipientWithAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.recipient = _data["recipient"] ? RecipientModel.fromJS(_data["recipient"], _mappings) : <any>undefined;
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"], _mappings) : <any>undefined;
            this.recipientId = _data["recipientId"];
            this.addressId = _data["addressId"];
            this.isDefaultAddress = _data["isDefaultAddress"];
        }
    }

    static fromJS(data: any, _mappings?: any): RecipientWithAddressModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RecipientWithAddressModel>(data, _mappings, RecipientWithAddressModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient ? this.recipient.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["recipientId"] = this.recipientId;
        data["addressId"] = this.addressId;
        data["isDefaultAddress"] = this.isDefaultAddress;
        return data;
    }
}

export interface IRecipientWithAddressModel {
    recipient?: RecipientModel;
    address?: AddressModel;
    recipientId?: number;
    addressId?: number;
    isDefaultAddress?: boolean;
}

export class RequestAdvanceSearchModel implements IRequestAdvanceSearchModel {
    year?: string | undefined;
    requestStatusId?: number[] | undefined;
    recipientType?: string | undefined;
    recipientEmails?: string[] | undefined;
    requesterEmails?: string[] | undefined;
    requestCreatedByList?: number[] | undefined;
    countryIds?: number[] | undefined;
    requestTypeIds?: number[] | undefined;
    sampleName?: string | undefined;
    requestNumber?: string | undefined;

    constructor(data?: IRequestAdvanceSearchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["requestStatusId"])) {
                this.requestStatusId = [] as any;
                for (let item of _data["requestStatusId"])
                    this.requestStatusId.push(item);
            }
            this.recipientType = _data["recipientType"];
            if (Array.isArray(_data["recipientEmails"])) {
                this.recipientEmails = [] as any;
                for (let item of _data["recipientEmails"])
                    this.recipientEmails.push(item);
            }
            if (Array.isArray(_data["requesterEmails"])) {
                this.requesterEmails = [] as any;
                for (let item of _data["requesterEmails"])
                    this.requesterEmails.push(item);
            }
            if (Array.isArray(_data["requestCreatedByList"])) {
                this.requestCreatedByList = [] as any;
                for (let item of _data["requestCreatedByList"])
                    this.requestCreatedByList.push(item);
            }
            if (Array.isArray(_data["countryIds"])) {
                this.countryIds = [] as any;
                for (let item of _data["countryIds"])
                    this.countryIds.push(item);
            }
            if (Array.isArray(_data["requestTypeIds"])) {
                this.requestTypeIds = [] as any;
                for (let item of _data["requestTypeIds"])
                    this.requestTypeIds.push(item);
            }
            this.sampleName = _data["sampleName"];
            this.requestNumber = _data["requestNumber"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestAdvanceSearchModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestAdvanceSearchModel>(data, _mappings, RequestAdvanceSearchModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.requestStatusId)) {
            data["requestStatusId"] = [];
            for (let item of this.requestStatusId)
                data["requestStatusId"].push(item);
        }
        data["recipientType"] = this.recipientType;
        if (Array.isArray(this.recipientEmails)) {
            data["recipientEmails"] = [];
            for (let item of this.recipientEmails)
                data["recipientEmails"].push(item);
        }
        if (Array.isArray(this.requesterEmails)) {
            data["requesterEmails"] = [];
            for (let item of this.requesterEmails)
                data["requesterEmails"].push(item);
        }
        if (Array.isArray(this.requestCreatedByList)) {
            data["requestCreatedByList"] = [];
            for (let item of this.requestCreatedByList)
                data["requestCreatedByList"].push(item);
        }
        if (Array.isArray(this.countryIds)) {
            data["countryIds"] = [];
            for (let item of this.countryIds)
                data["countryIds"].push(item);
        }
        if (Array.isArray(this.requestTypeIds)) {
            data["requestTypeIds"] = [];
            for (let item of this.requestTypeIds)
                data["requestTypeIds"].push(item);
        }
        data["sampleName"] = this.sampleName;
        data["requestNumber"] = this.requestNumber;
        return data;
    }
}

export interface IRequestAdvanceSearchModel {
    year?: string | undefined;
    requestStatusId?: number[] | undefined;
    recipientType?: string | undefined;
    recipientEmails?: string[] | undefined;
    requesterEmails?: string[] | undefined;
    requestCreatedByList?: number[] | undefined;
    countryIds?: number[] | undefined;
    requestTypeIds?: number[] | undefined;
    sampleName?: string | undefined;
    requestNumber?: string | undefined;
}

export class RequestItemAttachmentCommentModel implements IRequestItemAttachmentCommentModel {
    requestItemAttachmentId?: number;
    comment?: string | undefined;

    constructor(data?: IRequestItemAttachmentCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestItemAttachmentId = _data["requestItemAttachmentId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemAttachmentCommentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemAttachmentCommentModel>(data, _mappings, RequestItemAttachmentCommentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestItemAttachmentId"] = this.requestItemAttachmentId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IRequestItemAttachmentCommentModel {
    requestItemAttachmentId?: number;
    comment?: string | undefined;
}

export class RequestItemAttachmentModel implements IRequestItemAttachmentModel {
    requestItemAttachmentId?: number;
    requestItemId?: number;
    fileName?: string | undefined;
    file?: string | undefined;
    comment?: string | undefined;
    isAttachmentDeleted?: boolean;
    gssCommonId?: string | undefined;
    documentTypeId?: number | undefined;
    documentReferenceId?: string | undefined;

    constructor(data?: IRequestItemAttachmentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestItemAttachmentId = _data["requestItemAttachmentId"];
            this.requestItemId = _data["requestItemId"];
            this.fileName = _data["fileName"];
            this.file = _data["file"];
            this.comment = _data["comment"];
            this.isAttachmentDeleted = _data["isAttachmentDeleted"];
            this.gssCommonId = _data["gssCommonId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentReferenceId = _data["documentReferenceId"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemAttachmentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemAttachmentModel>(data, _mappings, RequestItemAttachmentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestItemAttachmentId"] = this.requestItemAttachmentId;
        data["requestItemId"] = this.requestItemId;
        data["fileName"] = this.fileName;
        data["file"] = this.file;
        data["comment"] = this.comment;
        data["isAttachmentDeleted"] = this.isAttachmentDeleted;
        data["gssCommonId"] = this.gssCommonId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentReferenceId"] = this.documentReferenceId;
        return data;
    }
}

export interface IRequestItemAttachmentModel {
    requestItemAttachmentId?: number;
    requestItemId?: number;
    fileName?: string | undefined;
    file?: string | undefined;
    comment?: string | undefined;
    isAttachmentDeleted?: boolean;
    gssCommonId?: string | undefined;
    documentTypeId?: number | undefined;
    documentReferenceId?: string | undefined;
}

export class RequestItemAttributeModel implements IRequestItemAttributeModel {
    id?: number;
    requestItemId?: number | undefined;
    cartItemId?: number | undefined;
    attributeName?: string | undefined;
    attributeValue?: string | undefined;
    isLotLevelAttribute?: boolean;

    constructor(data?: IRequestItemAttributeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestItemId = _data["requestItemId"];
            this.cartItemId = _data["cartItemId"];
            this.attributeName = _data["attributeName"];
            this.attributeValue = _data["attributeValue"];
            this.isLotLevelAttribute = _data["isLotLevelAttribute"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemAttributeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemAttributeModel>(data, _mappings, RequestItemAttributeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestItemId"] = this.requestItemId;
        data["cartItemId"] = this.cartItemId;
        data["attributeName"] = this.attributeName;
        data["attributeValue"] = this.attributeValue;
        data["isLotLevelAttribute"] = this.isLotLevelAttribute;
        return data;
    }
}

export interface IRequestItemAttributeModel {
    id?: number;
    requestItemId?: number | undefined;
    cartItemId?: number | undefined;
    attributeName?: string | undefined;
    attributeValue?: string | undefined;
    isLotLevelAttribute?: boolean;
}

export class RequestItemCommentModel implements IRequestItemCommentModel {
    id?: number;
    commentId?: number;
    requestItemId?: number;
    comment?: CommentModel;

    constructor(data?: IRequestItemCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commentId = _data["commentId"];
            this.requestItemId = _data["requestItemId"];
            this.comment = _data["comment"] ? CommentModel.fromJS(_data["comment"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemCommentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemCommentModel>(data, _mappings, RequestItemCommentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commentId"] = this.commentId;
        data["requestItemId"] = this.requestItemId;
        data["comment"] = this.comment ? this.comment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequestItemCommentModel {
    id?: number;
    commentId?: number;
    requestItemId?: number;
    comment?: CommentModel;
}

export class RequestItemContainerModel implements IRequestItemContainerModel {
    requestItemContainerId?: number;
    requestItemId?: number;
    numberOfContainer?: number;
    amountPerContainer?: number;
    containerLabel?: string | undefined;
    isContainerDeleted?: boolean;

    constructor(data?: IRequestItemContainerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestItemContainerId = _data["requestItemContainerId"];
            this.requestItemId = _data["requestItemId"];
            this.numberOfContainer = _data["numberOfContainer"];
            this.amountPerContainer = _data["amountPerContainer"];
            this.containerLabel = _data["containerLabel"];
            this.isContainerDeleted = _data["isContainerDeleted"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemContainerModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemContainerModel>(data, _mappings, RequestItemContainerModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestItemContainerId"] = this.requestItemContainerId;
        data["requestItemId"] = this.requestItemId;
        data["numberOfContainer"] = this.numberOfContainer;
        data["amountPerContainer"] = this.amountPerContainer;
        data["containerLabel"] = this.containerLabel;
        data["isContainerDeleted"] = this.isContainerDeleted;
        return data;
    }
}

export interface IRequestItemContainerModel {
    requestItemContainerId?: number;
    requestItemId?: number;
    numberOfContainer?: number;
    amountPerContainer?: number;
    containerLabel?: string | undefined;
    isContainerDeleted?: boolean;
}

export class RequestItemEupDocumentModel implements IRequestItemEupDocumentModel {
    requestId?: number;
    sendInvoiceBefore?: boolean | undefined;
    sds?: boolean | undefined;
    coo?: boolean | undefined;
    coA?: boolean | undefined;
    otherDoc?: boolean | undefined;
    otherDocText?: string | undefined;

    constructor(data?: IRequestItemEupDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.sendInvoiceBefore = _data["sendInvoiceBefore"];
            this.sds = _data["sds"];
            this.coo = _data["coo"];
            this.coA = _data["coA"];
            this.otherDoc = _data["otherDoc"];
            this.otherDocText = _data["otherDocText"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemEupDocumentModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemEupDocumentModel>(data, _mappings, RequestItemEupDocumentModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["sendInvoiceBefore"] = this.sendInvoiceBefore;
        data["sds"] = this.sds;
        data["coo"] = this.coo;
        data["coA"] = this.coA;
        data["otherDoc"] = this.otherDoc;
        data["otherDocText"] = this.otherDocText;
        return data;
    }
}

export interface IRequestItemEupDocumentModel {
    requestId?: number;
    sendInvoiceBefore?: boolean | undefined;
    sds?: boolean | undefined;
    coo?: boolean | undefined;
    coA?: boolean | undefined;
    otherDoc?: boolean | undefined;
    otherDocText?: string | undefined;
}

export class RequestItemModel implements IRequestItemModel {
    requestItemId?: number;
    requestId?: number;
    chemicalName?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    nominalComposition?: string | undefined;
    lotNumber?: string | undefined;
    recertificationDate?: Date | undefined;
    availableAmount?: number | undefined;
    tsnNumber?: string | undefined;
    unitOfMeasureId?: number | undefined;
    unitOfMeasure?: string | undefined;
    containerLabel?: string | undefined;
    isUserDefinedContainerLabel?: boolean | undefined;
    coA?: boolean | undefined;
    sendInvoiceBefore?: boolean | undefined;
    sds?: boolean | undefined;
    coo?: boolean | undefined;
    otherDoc?: boolean | undefined;
    otherDocText?: string | undefined;
    totalRequestedQuantity?: number;
    requestItemContainerList?: RequestItemContainerModel[] | undefined;
    requestItemAttachmentList?: RequestItemAttachmentModel[] | undefined;
    requestItemComment?: RequestItemCommentModel[] | undefined;
    materialId?: string | undefined;
    priority?: string | undefined;
    requestLocationId?: number;
    amountForecasted?: number;
    amountRemaining?: number;
    needByDate?: Date | undefined;
    shipNow?: boolean | undefined;
    forecastRequesterId?: number | undefined;
    farmLocationId?: number | undefined;
    forecastId?: number | undefined;
    isReachCompliant?: boolean;
    country?: string | undefined;
    farmInventoryStatus?: string | undefined;
    farmInventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    materialSearchType?: string | undefined;
    isApproved?: boolean | undefined;
    approvedAt?: Date | undefined;
    packedWithChoiceId?: number | undefined;
    packedWithChoiceName?: string | undefined;
    exportTariffCode?: string | undefined;
    importTariffCode?: string | undefined;
    eccn?: string | undefined;
    customsValue?: number | undefined;
    isPermitRequired?: boolean;
    isBioFormulation?: boolean;
    isPermitAvailable?: boolean | undefined;

    constructor(data?: IRequestItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestItemId = _data["requestItemId"];
            this.requestId = _data["requestId"];
            this.chemicalName = _data["chemicalName"];
            this.repoName = _data["repoName"];
            this.synonyms = _data["synonyms"];
            this.nominalComposition = _data["nominalComposition"];
            this.lotNumber = _data["lotNumber"];
            this.recertificationDate = _data["recertificationDate"] ? new Date(_data["recertificationDate"].toString()) : <any>undefined;
            this.availableAmount = _data["availableAmount"];
            this.tsnNumber = _data["tsnNumber"];
            this.unitOfMeasureId = _data["unitOfMeasureId"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.containerLabel = _data["containerLabel"];
            this.isUserDefinedContainerLabel = _data["isUserDefinedContainerLabel"];
            this.coA = _data["coA"];
            this.sendInvoiceBefore = _data["sendInvoiceBefore"];
            this.sds = _data["sds"];
            this.coo = _data["coo"];
            this.otherDoc = _data["otherDoc"];
            this.otherDocText = _data["otherDocText"];
            this.totalRequestedQuantity = _data["totalRequestedQuantity"];
            if (Array.isArray(_data["requestItemContainerList"])) {
                this.requestItemContainerList = [] as any;
                for (let item of _data["requestItemContainerList"])
                    this.requestItemContainerList.push(RequestItemContainerModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["requestItemAttachmentList"])) {
                this.requestItemAttachmentList = [] as any;
                for (let item of _data["requestItemAttachmentList"])
                    this.requestItemAttachmentList.push(RequestItemAttachmentModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["requestItemComment"])) {
                this.requestItemComment = [] as any;
                for (let item of _data["requestItemComment"])
                    this.requestItemComment.push(RequestItemCommentModel.fromJS(item, _mappings));
            }
            this.materialId = _data["materialId"];
            this.priority = _data["priority"];
            this.requestLocationId = _data["requestLocationId"];
            this.amountForecasted = _data["amountForecasted"];
            this.amountRemaining = _data["amountRemaining"];
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : <any>undefined;
            this.shipNow = _data["shipNow"];
            this.forecastRequesterId = _data["forecastRequesterId"];
            this.farmLocationId = _data["farmLocationId"];
            this.forecastId = _data["forecastId"];
            this.isReachCompliant = _data["isReachCompliant"];
            this.country = _data["country"];
            this.farmInventoryStatus = _data["farmInventoryStatus"];
            this.farmInventoryLocation = _data["farmInventoryLocation"];
            this.warehouseId = _data["warehouseId"];
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.materialSearchType = _data["materialSearchType"];
            this.isApproved = _data["isApproved"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : <any>undefined;
            this.packedWithChoiceId = _data["packedWithChoiceId"];
            this.packedWithChoiceName = _data["packedWithChoiceName"];
            this.exportTariffCode = _data["exportTariffCode"];
            this.importTariffCode = _data["importTariffCode"];
            this.eccn = _data["eccn"];
            this.customsValue = _data["customsValue"];
            this.isPermitRequired = _data["isPermitRequired"];
            this.isBioFormulation = _data["isBioFormulation"];
            this.isPermitAvailable = _data["isPermitAvailable"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemModel>(data, _mappings, RequestItemModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestItemId"] = this.requestItemId;
        data["requestId"] = this.requestId;
        data["chemicalName"] = this.chemicalName;
        data["repoName"] = this.repoName;
        data["synonyms"] = this.synonyms;
        data["nominalComposition"] = this.nominalComposition;
        data["lotNumber"] = this.lotNumber;
        data["recertificationDate"] = this.recertificationDate ? this.recertificationDate.toISOString() : <any>undefined;
        data["availableAmount"] = this.availableAmount;
        data["tsnNumber"] = this.tsnNumber;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["containerLabel"] = this.containerLabel;
        data["isUserDefinedContainerLabel"] = this.isUserDefinedContainerLabel;
        data["coA"] = this.coA;
        data["sendInvoiceBefore"] = this.sendInvoiceBefore;
        data["sds"] = this.sds;
        data["coo"] = this.coo;
        data["otherDoc"] = this.otherDoc;
        data["otherDocText"] = this.otherDocText;
        data["totalRequestedQuantity"] = this.totalRequestedQuantity;
        if (Array.isArray(this.requestItemContainerList)) {
            data["requestItemContainerList"] = [];
            for (let item of this.requestItemContainerList)
                data["requestItemContainerList"].push(item.toJSON());
        }
        if (Array.isArray(this.requestItemAttachmentList)) {
            data["requestItemAttachmentList"] = [];
            for (let item of this.requestItemAttachmentList)
                data["requestItemAttachmentList"].push(item.toJSON());
        }
        if (Array.isArray(this.requestItemComment)) {
            data["requestItemComment"] = [];
            for (let item of this.requestItemComment)
                data["requestItemComment"].push(item.toJSON());
        }
        data["materialId"] = this.materialId;
        data["priority"] = this.priority;
        data["requestLocationId"] = this.requestLocationId;
        data["amountForecasted"] = this.amountForecasted;
        data["amountRemaining"] = this.amountRemaining;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : <any>undefined;
        data["shipNow"] = this.shipNow;
        data["forecastRequesterId"] = this.forecastRequesterId;
        data["farmLocationId"] = this.farmLocationId;
        data["forecastId"] = this.forecastId;
        data["isReachCompliant"] = this.isReachCompliant;
        data["country"] = this.country;
        data["farmInventoryStatus"] = this.farmInventoryStatus;
        data["farmInventoryLocation"] = this.farmInventoryLocation;
        data["warehouseId"] = this.warehouseId;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["materialSearchType"] = this.materialSearchType;
        data["isApproved"] = this.isApproved;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : <any>undefined;
        data["packedWithChoiceId"] = this.packedWithChoiceId;
        data["packedWithChoiceName"] = this.packedWithChoiceName;
        data["exportTariffCode"] = this.exportTariffCode;
        data["importTariffCode"] = this.importTariffCode;
        data["eccn"] = this.eccn;
        data["customsValue"] = this.customsValue;
        data["isPermitRequired"] = this.isPermitRequired;
        data["isBioFormulation"] = this.isBioFormulation;
        data["isPermitAvailable"] = this.isPermitAvailable;
        return data;
    }
}

export interface IRequestItemModel {
    requestItemId?: number;
    requestId?: number;
    chemicalName?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    nominalComposition?: string | undefined;
    lotNumber?: string | undefined;
    recertificationDate?: Date | undefined;
    availableAmount?: number | undefined;
    tsnNumber?: string | undefined;
    unitOfMeasureId?: number | undefined;
    unitOfMeasure?: string | undefined;
    containerLabel?: string | undefined;
    isUserDefinedContainerLabel?: boolean | undefined;
    coA?: boolean | undefined;
    sendInvoiceBefore?: boolean | undefined;
    sds?: boolean | undefined;
    coo?: boolean | undefined;
    otherDoc?: boolean | undefined;
    otherDocText?: string | undefined;
    totalRequestedQuantity?: number;
    requestItemContainerList?: RequestItemContainerModel[] | undefined;
    requestItemAttachmentList?: RequestItemAttachmentModel[] | undefined;
    requestItemComment?: RequestItemCommentModel[] | undefined;
    materialId?: string | undefined;
    priority?: string | undefined;
    requestLocationId?: number;
    amountForecasted?: number;
    amountRemaining?: number;
    needByDate?: Date | undefined;
    shipNow?: boolean | undefined;
    forecastRequesterId?: number | undefined;
    farmLocationId?: number | undefined;
    forecastId?: number | undefined;
    isReachCompliant?: boolean;
    country?: string | undefined;
    farmInventoryStatus?: string | undefined;
    farmInventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    materialSearchType?: string | undefined;
    isApproved?: boolean | undefined;
    approvedAt?: Date | undefined;
    packedWithChoiceId?: number | undefined;
    packedWithChoiceName?: string | undefined;
    exportTariffCode?: string | undefined;
    importTariffCode?: string | undefined;
    eccn?: string | undefined;
    customsValue?: number | undefined;
    isPermitRequired?: boolean;
    isBioFormulation?: boolean;
    isPermitAvailable?: boolean | undefined;
}

export class RequestItemPriorityModel implements IRequestItemPriorityModel {
    requestId?: number;
    priority?: string | undefined;
    shipNow?: boolean | undefined;
    needByDate?: Date | undefined;

    constructor(data?: IRequestItemPriorityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.priority = _data["priority"];
            this.shipNow = _data["shipNow"];
            this.needByDate = _data["needByDate"] ? new Date(_data["needByDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemPriorityModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemPriorityModel>(data, _mappings, RequestItemPriorityModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["priority"] = this.priority;
        data["shipNow"] = this.shipNow;
        data["needByDate"] = this.needByDate ? this.needByDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRequestItemPriorityModel {
    requestId?: number;
    priority?: string | undefined;
    shipNow?: boolean | undefined;
    needByDate?: Date | undefined;
}

export class RequestItemQuestionResponsesModel implements IRequestItemQuestionResponsesModel {
    questionResponseId?: number;
    requestItemId?: number;
    questionId?: number;
    response?: string | undefined;
    additionalResponse?: string | undefined;

    constructor(data?: IRequestItemQuestionResponsesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.questionResponseId = _data["questionResponseId"];
            this.requestItemId = _data["requestItemId"];
            this.questionId = _data["questionId"];
            this.response = _data["response"];
            this.additionalResponse = _data["additionalResponse"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestItemQuestionResponsesModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestItemQuestionResponsesModel>(data, _mappings, RequestItemQuestionResponsesModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionResponseId"] = this.questionResponseId;
        data["requestItemId"] = this.requestItemId;
        data["questionId"] = this.questionId;
        data["response"] = this.response;
        data["additionalResponse"] = this.additionalResponse;
        return data;
    }
}

export interface IRequestItemQuestionResponsesModel {
    questionResponseId?: number;
    requestItemId?: number;
    questionId?: number;
    response?: string | undefined;
    additionalResponse?: string | undefined;
}

export class RequestModel implements IRequestModel {
    requestId?: number;
    requestNumber?: string | undefined;
    requestTypeId?: number;
    requestTypeName?: string | undefined;
    requestCreatedBy?: string | undefined;
    requestCreatedOn?: Date;
    requestStatus?: string | undefined;
    isCopy?: boolean;
    favoriteId?: number;
    isFavorite?: boolean;
    countryName?: string | undefined;
    year?: string | undefined;
    requesterInformationModel?: RequesterInformationModel;
    requester?: string | undefined;
    shippingOption?: string | undefined;
    recipient?: string | undefined;
    isExternalRecipient?: boolean;
    isForecastRequest?: boolean;
    isRegion?: boolean;
    countryId?: number;
    alchemistOrderId?: string | undefined;
    submittedBy?: string | undefined;
    submittedOn?: Date | undefined;
    orderCoordinatorName?: string | undefined;
    orderCoordinatorEmail?: string | undefined;
    orderSplitInAlchemist?: boolean;
    isIndyAligned?: boolean | undefined;
    materials?: string[] | undefined;

    constructor(data?: IRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.requestNumber = _data["requestNumber"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestTypeName = _data["requestTypeName"];
            this.requestCreatedBy = _data["requestCreatedBy"];
            this.requestCreatedOn = _data["requestCreatedOn"] ? new Date(_data["requestCreatedOn"].toString()) : <any>undefined;
            this.requestStatus = _data["requestStatus"];
            this.isCopy = _data["isCopy"];
            this.favoriteId = _data["favoriteId"];
            this.isFavorite = _data["isFavorite"];
            this.countryName = _data["countryName"];
            this.year = _data["year"];
            this.requesterInformationModel = _data["requesterInformationModel"] ? RequesterInformationModel.fromJS(_data["requesterInformationModel"], _mappings) : <any>undefined;
            this.requester = _data["requester"];
            this.shippingOption = _data["shippingOption"];
            this.recipient = _data["recipient"];
            this.isExternalRecipient = _data["isExternalRecipient"];
            this.isForecastRequest = _data["isForecastRequest"];
            this.isRegion = _data["isRegion"];
            this.countryId = _data["countryId"];
            this.alchemistOrderId = _data["alchemistOrderId"];
            this.submittedBy = _data["submittedBy"];
            this.submittedOn = _data["submittedOn"] ? new Date(_data["submittedOn"].toString()) : <any>undefined;
            this.orderCoordinatorName = _data["orderCoordinatorName"];
            this.orderCoordinatorEmail = _data["orderCoordinatorEmail"];
            this.orderSplitInAlchemist = _data["orderSplitInAlchemist"];
            this.isIndyAligned = _data["isIndyAligned"];
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RequestModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestModel>(data, _mappings, RequestModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["requestNumber"] = this.requestNumber;
        data["requestTypeId"] = this.requestTypeId;
        data["requestTypeName"] = this.requestTypeName;
        data["requestCreatedBy"] = this.requestCreatedBy;
        data["requestCreatedOn"] = this.requestCreatedOn ? this.requestCreatedOn.toISOString() : <any>undefined;
        data["requestStatus"] = this.requestStatus;
        data["isCopy"] = this.isCopy;
        data["favoriteId"] = this.favoriteId;
        data["isFavorite"] = this.isFavorite;
        data["countryName"] = this.countryName;
        data["year"] = this.year;
        data["requesterInformationModel"] = this.requesterInformationModel ? this.requesterInformationModel.toJSON() : <any>undefined;
        data["requester"] = this.requester;
        data["shippingOption"] = this.shippingOption;
        data["recipient"] = this.recipient;
        data["isExternalRecipient"] = this.isExternalRecipient;
        data["isForecastRequest"] = this.isForecastRequest;
        data["isRegion"] = this.isRegion;
        data["countryId"] = this.countryId;
        data["alchemistOrderId"] = this.alchemistOrderId;
        data["submittedBy"] = this.submittedBy;
        data["submittedOn"] = this.submittedOn ? this.submittedOn.toISOString() : <any>undefined;
        data["orderCoordinatorName"] = this.orderCoordinatorName;
        data["orderCoordinatorEmail"] = this.orderCoordinatorEmail;
        data["orderSplitInAlchemist"] = this.orderSplitInAlchemist;
        data["isIndyAligned"] = this.isIndyAligned;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item);
        }
        return data;
    }
}

export interface IRequestModel {
    requestId?: number;
    requestNumber?: string | undefined;
    requestTypeId?: number;
    requestTypeName?: string | undefined;
    requestCreatedBy?: string | undefined;
    requestCreatedOn?: Date;
    requestStatus?: string | undefined;
    isCopy?: boolean;
    favoriteId?: number;
    isFavorite?: boolean;
    countryName?: string | undefined;
    year?: string | undefined;
    requesterInformationModel?: RequesterInformationModel;
    requester?: string | undefined;
    shippingOption?: string | undefined;
    recipient?: string | undefined;
    isExternalRecipient?: boolean;
    isForecastRequest?: boolean;
    isRegion?: boolean;
    countryId?: number;
    alchemistOrderId?: string | undefined;
    submittedBy?: string | undefined;
    submittedOn?: Date | undefined;
    orderCoordinatorName?: string | undefined;
    orderCoordinatorEmail?: string | undefined;
    orderSplitInAlchemist?: boolean;
    isIndyAligned?: boolean | undefined;
    materials?: string[] | undefined;
}

export class RequestNotificationModel implements IRequestNotificationModel {
    requestNotificationId?: number;
    requestId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    email?: string | undefined;
    description?: string | undefined;
    isRequestNotificationDeleted?: boolean;

    constructor(data?: IRequestNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestNotificationId = _data["requestNotificationId"];
            this.requestId = _data["requestId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.email = _data["email"];
            this.description = _data["description"];
            this.isRequestNotificationDeleted = _data["isRequestNotificationDeleted"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestNotificationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestNotificationModel>(data, _mappings, RequestNotificationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestNotificationId"] = this.requestNotificationId;
        data["requestId"] = this.requestId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["email"] = this.email;
        data["description"] = this.description;
        data["isRequestNotificationDeleted"] = this.isRequestNotificationDeleted;
        return data;
    }
}

export interface IRequestNotificationModel {
    requestNotificationId?: number;
    requestId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    email?: string | undefined;
    description?: string | undefined;
    isRequestNotificationDeleted?: boolean;
}

export class RequestStatusModel implements IRequestStatusModel {
    requestStatusId?: number;
    requestId?: number;
    requestStatusTypeId?: number;

    constructor(data?: IRequestStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestStatusId = _data["requestStatusId"];
            this.requestId = _data["requestId"];
            this.requestStatusTypeId = _data["requestStatusTypeId"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequestStatusModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequestStatusModel>(data, _mappings, RequestStatusModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestStatusId"] = this.requestStatusId;
        data["requestId"] = this.requestId;
        data["requestStatusTypeId"] = this.requestStatusTypeId;
        return data;
    }
}

export interface IRequestStatusModel {
    requestStatusId?: number;
    requestId?: number;
    requestStatusTypeId?: number;
}

export class RequesterDelegatorModel implements IRequesterDelegatorModel {
    requesterDelegatorId?: number;
    requesterId?: number;
    delegatorId?: number;
    requestTypeId?: number;
    requesterName?: string | undefined;
    delegatorName?: string | undefined;
    supervisor?: string | undefined;
    function?: string | undefined;
    email?: string | undefined;
    requesterEmail?: string | undefined;
    country?: string | undefined;
    requestTypeName?: string | undefined;

    constructor(data?: IRequesterDelegatorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requesterDelegatorId = _data["requesterDelegatorId"];
            this.requesterId = _data["requesterId"];
            this.delegatorId = _data["delegatorId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requesterName = _data["requesterName"];
            this.delegatorName = _data["delegatorName"];
            this.supervisor = _data["supervisor"];
            this.function = _data["function"];
            this.email = _data["email"];
            this.requesterEmail = _data["requesterEmail"];
            this.country = _data["country"];
            this.requestTypeName = _data["requestTypeName"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequesterDelegatorModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequesterDelegatorModel>(data, _mappings, RequesterDelegatorModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requesterDelegatorId"] = this.requesterDelegatorId;
        data["requesterId"] = this.requesterId;
        data["delegatorId"] = this.delegatorId;
        data["requestTypeId"] = this.requestTypeId;
        data["requesterName"] = this.requesterName;
        data["delegatorName"] = this.delegatorName;
        data["supervisor"] = this.supervisor;
        data["function"] = this.function;
        data["email"] = this.email;
        data["requesterEmail"] = this.requesterEmail;
        data["country"] = this.country;
        data["requestTypeName"] = this.requestTypeName;
        return data;
    }
}

export interface IRequesterDelegatorModel {
    requesterDelegatorId?: number;
    requesterId?: number;
    delegatorId?: number;
    requestTypeId?: number;
    requesterName?: string | undefined;
    delegatorName?: string | undefined;
    supervisor?: string | undefined;
    function?: string | undefined;
    email?: string | undefined;
    requesterEmail?: string | undefined;
    country?: string | undefined;
    requestTypeName?: string | undefined;
}

export class RequesterInformationModel implements IRequesterInformationModel {
    requesterInformationId?: number;
    requestId?: number;
    displayName?: string | undefined;
    email?: string | undefined;
    contactNumber?: string | undefined;
    requesterAddressId?: number | undefined;
    isExternalAddress?: boolean | undefined;
    requesterAddress?: AddressModel;
    deliveryDate?: Date | undefined;
    siteName?: string | undefined;

    constructor(data?: IRequesterInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requesterInformationId = _data["requesterInformationId"];
            this.requestId = _data["requestId"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.contactNumber = _data["contactNumber"];
            this.requesterAddressId = _data["requesterAddressId"];
            this.isExternalAddress = _data["isExternalAddress"];
            this.requesterAddress = _data["requesterAddress"] ? AddressModel.fromJS(_data["requesterAddress"], _mappings) : <any>undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.siteName = _data["siteName"];
        }
    }

    static fromJS(data: any, _mappings?: any): RequesterInformationModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RequesterInformationModel>(data, _mappings, RequesterInformationModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requesterInformationId"] = this.requesterInformationId;
        data["requestId"] = this.requestId;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["contactNumber"] = this.contactNumber;
        data["requesterAddressId"] = this.requesterAddressId;
        data["isExternalAddress"] = this.isExternalAddress;
        data["requesterAddress"] = this.requesterAddress ? this.requesterAddress.toJSON() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["siteName"] = this.siteName;
        return data;
    }
}

export interface IRequesterInformationModel {
    requesterInformationId?: number;
    requestId?: number;
    displayName?: string | undefined;
    email?: string | undefined;
    contactNumber?: string | undefined;
    requesterAddressId?: number | undefined;
    isExternalAddress?: boolean | undefined;
    requesterAddress?: AddressModel;
    deliveryDate?: Date | undefined;
    siteName?: string | undefined;
}

export class SaveCartItem implements ISaveCartItem {
    cartItemId?: number;
    materialName?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    lotNumber?: string | undefined;
    recertificationDate?: Date | undefined;
    availableAmount?: number | undefined;
    tsnNumber?: string | undefined;
    createdDate?: Date;
    materialId?: string | undefined;
    requestTypeId?: number;
    nominalConcentration?: string | undefined;
    formulationType?: string | undefined;
    purity?: string | undefined;
    gfCode?: string | undefined;
    activeIngredient?: string | undefined;
    requestLocationId?: number;
    forecastRequesterId?: number;
    forecastId?: number | undefined;
    farmInventoryStatus?: string | undefined;
    farmInventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    materialSearchType?: string | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    isBioFormulation?: boolean;
    requestItemAttributes?: RequestItemAttributeModel[] | undefined;

    constructor(data?: ISaveCartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.cartItemId = _data["cartItemId"];
            this.materialName = _data["materialName"];
            this.repoName = _data["repoName"];
            this.synonyms = _data["synonyms"];
            this.lotNumber = _data["lotNumber"];
            this.recertificationDate = _data["recertificationDate"] ? new Date(_data["recertificationDate"].toString()) : <any>undefined;
            this.availableAmount = _data["availableAmount"];
            this.tsnNumber = _data["tsnNumber"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.materialId = _data["materialId"];
            this.requestTypeId = _data["requestTypeId"];
            this.nominalConcentration = _data["nominalConcentration"];
            this.formulationType = _data["formulationType"];
            this.purity = _data["purity"];
            this.gfCode = _data["gfCode"];
            this.activeIngredient = _data["activeIngredient"];
            this.requestLocationId = _data["requestLocationId"];
            this.forecastRequesterId = _data["forecastRequesterId"];
            this.forecastId = _data["forecastId"];
            this.farmInventoryStatus = _data["farmInventoryStatus"];
            this.farmInventoryLocation = _data["farmInventoryLocation"];
            this.warehouseId = _data["warehouseId"];
            this.materialSearchType = _data["materialSearchType"];
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.isBioFormulation = _data["isBioFormulation"];
            if (Array.isArray(_data["requestItemAttributes"])) {
                this.requestItemAttributes = [] as any;
                for (let item of _data["requestItemAttributes"])
                    this.requestItemAttributes.push(RequestItemAttributeModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveCartItem | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveCartItem>(data, _mappings, SaveCartItem);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartItemId"] = this.cartItemId;
        data["materialName"] = this.materialName;
        data["repoName"] = this.repoName;
        data["synonyms"] = this.synonyms;
        data["lotNumber"] = this.lotNumber;
        data["recertificationDate"] = this.recertificationDate ? this.recertificationDate.toISOString() : <any>undefined;
        data["availableAmount"] = this.availableAmount;
        data["tsnNumber"] = this.tsnNumber;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["materialId"] = this.materialId;
        data["requestTypeId"] = this.requestTypeId;
        data["nominalConcentration"] = this.nominalConcentration;
        data["formulationType"] = this.formulationType;
        data["purity"] = this.purity;
        data["gfCode"] = this.gfCode;
        data["activeIngredient"] = this.activeIngredient;
        data["requestLocationId"] = this.requestLocationId;
        data["forecastRequesterId"] = this.forecastRequesterId;
        data["forecastId"] = this.forecastId;
        data["farmInventoryStatus"] = this.farmInventoryStatus;
        data["farmInventoryLocation"] = this.farmInventoryLocation;
        data["warehouseId"] = this.warehouseId;
        data["materialSearchType"] = this.materialSearchType;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["isBioFormulation"] = this.isBioFormulation;
        if (Array.isArray(this.requestItemAttributes)) {
            data["requestItemAttributes"] = [];
            for (let item of this.requestItemAttributes)
                data["requestItemAttributes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveCartItem {
    cartItemId?: number;
    materialName?: string | undefined;
    repoName?: string | undefined;
    synonyms?: string | undefined;
    lotNumber?: string | undefined;
    recertificationDate?: Date | undefined;
    availableAmount?: number | undefined;
    tsnNumber?: string | undefined;
    createdDate?: Date;
    materialId?: string | undefined;
    requestTypeId?: number;
    nominalConcentration?: string | undefined;
    formulationType?: string | undefined;
    purity?: string | undefined;
    gfCode?: string | undefined;
    activeIngredient?: string | undefined;
    requestLocationId?: number;
    forecastRequesterId?: number;
    forecastId?: number | undefined;
    farmInventoryStatus?: string | undefined;
    farmInventoryLocation?: string | undefined;
    warehouseId?: number | undefined;
    materialSearchType?: string | undefined;
    approverName?: string | undefined;
    approverEmail?: string | undefined;
    isBioFormulation?: boolean;
    requestItemAttributes?: RequestItemAttributeModel[] | undefined;
}

export class SaveCartItemModel implements ISaveCartItemModel {
    cartItem?: SaveCartItem;
    searchString?: string | undefined;
    cartRequestTypeId?: number;

    constructor(data?: ISaveCartItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.cartItem = _data["cartItem"] ? SaveCartItem.fromJS(_data["cartItem"], _mappings) : <any>undefined;
            this.searchString = _data["searchString"];
            this.cartRequestTypeId = _data["cartRequestTypeId"];
        }
    }

    static fromJS(data: any, _mappings?: any): SaveCartItemModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveCartItemModel>(data, _mappings, SaveCartItemModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartItem"] = this.cartItem ? this.cartItem.toJSON() : <any>undefined;
        data["searchString"] = this.searchString;
        data["cartRequestTypeId"] = this.cartRequestTypeId;
        return data;
    }
}

export interface ISaveCartItemModel {
    cartItem?: SaveCartItem;
    searchString?: string | undefined;
    cartRequestTypeId?: number;
}

export class SaveQuestionnaireModel implements ISaveQuestionnaireModel {
    responseString?: string | undefined;
    responses?: RequestItemQuestionResponsesModel[] | undefined;

    constructor(data?: ISaveQuestionnaireModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.responseString = _data["responseString"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses.push(RequestItemQuestionResponsesModel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): SaveQuestionnaireModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SaveQuestionnaireModel>(data, _mappings, SaveQuestionnaireModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseString"] = this.responseString;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveQuestionnaireModel {
    responseString?: string | undefined;
    responses?: RequestItemQuestionResponsesModel[] | undefined;
}

export class ShipmentAddressModel implements IShipmentAddressModel {
    requestShipmentId?: number;
    requestId?: number;
    recipientId?: number;
    addressId?: number;

    constructor(data?: IShipmentAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestShipmentId = _data["requestShipmentId"];
            this.requestId = _data["requestId"];
            this.recipientId = _data["recipientId"];
            this.addressId = _data["addressId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ShipmentAddressModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ShipmentAddressModel>(data, _mappings, ShipmentAddressModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestShipmentId"] = this.requestShipmentId;
        data["requestId"] = this.requestId;
        data["recipientId"] = this.recipientId;
        data["addressId"] = this.addressId;
        return data;
    }
}

export interface IShipmentAddressModel {
    requestShipmentId?: number;
    requestId?: number;
    recipientId?: number;
    addressId?: number;
}

export class SystemSettingsModel implements ISystemSettingsModel {
    systemSettingsId?: number;
    key?: string | undefined;
    value?: string | undefined;
    dataTypeId?: number;
    description?: string | undefined;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date;
    modifiedBy?: number;

    constructor(data?: ISystemSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.systemSettingsId = _data["systemSettingsId"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.dataTypeId = _data["dataTypeId"];
            this.description = _data["description"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any, _mappings?: any): SystemSettingsModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<SystemSettingsModel>(data, _mappings, SystemSettingsModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemSettingsId"] = this.systemSettingsId;
        data["key"] = this.key;
        data["value"] = this.value;
        data["dataTypeId"] = this.dataTypeId;
        data["description"] = this.description;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface ISystemSettingsModel {
    systemSettingsId?: number;
    key?: string | undefined;
    value?: string | undefined;
    dataTypeId?: number;
    description?: string | undefined;
    createdDate?: Date;
    createdBy?: number;
    modifiedDate?: Date;
    modifiedBy?: number;
}

export class UOMConversion implements IUOMConversion {
    amount?: number;
    abbreviation?: string | undefined;
    readonly amountWithUnit?: string | undefined;

    constructor(data?: IUOMConversion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.abbreviation = _data["abbreviation"];
            (<any>this).amountWithUnit = _data["amountWithUnit"];
        }
    }

    static fromJS(data: any, _mappings?: any): UOMConversion | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UOMConversion>(data, _mappings, UOMConversion);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["abbreviation"] = this.abbreviation;
        data["amountWithUnit"] = this.amountWithUnit;
        return data;
    }
}

export interface IUOMConversion {
    amount?: number;
    abbreviation?: string | undefined;
    amountWithUnit?: string | undefined;
}

export class UOMItemConversion implements IUOMItemConversion {
    productSourceSystem: string;
    productIdentifier: string;
    amount: number;
    fromUnit: string;
    toUnit: string;

    constructor(data?: IUOMItemConversion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productSourceSystem = _data["productSourceSystem"];
            this.productIdentifier = _data["productIdentifier"];
            this.amount = _data["amount"];
            this.fromUnit = _data["fromUnit"];
            this.toUnit = _data["toUnit"];
        }
    }

    static fromJS(data: any, _mappings?: any): UOMItemConversion | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UOMItemConversion>(data, _mappings, UOMItemConversion);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productSourceSystem"] = this.productSourceSystem;
        data["productIdentifier"] = this.productIdentifier;
        data["amount"] = this.amount;
        data["fromUnit"] = this.fromUnit;
        data["toUnit"] = this.toUnit;
        return data;
    }
}

export interface IUOMItemConversion {
    productSourceSystem: string;
    productIdentifier: string;
    amount: number;
    fromUnit: string;
    toUnit: string;
}

export class UnitOfMeasureModel implements IUnitOfMeasureModel {
    requestTypeUnitOfMeasureId?: number;
    unitOfMeasureId?: number;
    requestTypeId?: number;
    unitOfMeasure?: string | undefined;
    description?: string | undefined;
    requestType?: string | undefined;
    isActive?: boolean;
    createdDate?: Date;
    createdBy?: string | undefined;

    constructor(data?: IUnitOfMeasureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.requestTypeUnitOfMeasureId = _data["requestTypeUnitOfMeasureId"];
            this.unitOfMeasureId = _data["unitOfMeasureId"];
            this.requestTypeId = _data["requestTypeId"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.description = _data["description"];
            this.requestType = _data["requestType"];
            this.isActive = _data["isActive"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any, _mappings?: any): UnitOfMeasureModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UnitOfMeasureModel>(data, _mappings, UnitOfMeasureModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestTypeUnitOfMeasureId"] = this.requestTypeUnitOfMeasureId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["requestTypeId"] = this.requestTypeId;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["description"] = this.description;
        data["requestType"] = this.requestType;
        data["isActive"] = this.isActive;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IUnitOfMeasureModel {
    requestTypeUnitOfMeasureId?: number;
    unitOfMeasureId?: number;
    requestTypeId?: number;
    unitOfMeasure?: string | undefined;
    description?: string | undefined;
    requestType?: string | undefined;
    isActive?: boolean;
    createdDate?: Date;
    createdBy?: string | undefined;
}

export class UserModel implements IUserModel {
    userId?: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    isEnabled?: boolean;
    regionId?: number;
    regionName?: string | undefined;
    countryId?: number;
    countryName?: string | undefined;
    supervisorName?: string | undefined;
    functionId?: number;
    functionName?: string | undefined;
    createdDate?: Date;
    userRequestTypeRoleList?: UserRequestTypeRoleModel[] | undefined;
    displayName?: string | undefined;
    awaitingApproval?: boolean | undefined;
    optInEmailNotification?: boolean | undefined;
    isApprover?: boolean;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.isEnabled = _data["isEnabled"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.supervisorName = _data["supervisorName"];
            this.functionId = _data["functionId"];
            this.functionName = _data["functionName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["userRequestTypeRoleList"])) {
                this.userRequestTypeRoleList = [] as any;
                for (let item of _data["userRequestTypeRoleList"])
                    this.userRequestTypeRoleList.push(UserRequestTypeRoleModel.fromJS(item, _mappings));
            }
            this.displayName = _data["displayName"];
            this.awaitingApproval = _data["awaitingApproval"];
            this.optInEmailNotification = _data["optInEmailNotification"];
            this.isApprover = _data["isApprover"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserModel>(data, _mappings, UserModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isEnabled"] = this.isEnabled;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["supervisorName"] = this.supervisorName;
        data["functionId"] = this.functionId;
        data["functionName"] = this.functionName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        if (Array.isArray(this.userRequestTypeRoleList)) {
            data["userRequestTypeRoleList"] = [];
            for (let item of this.userRequestTypeRoleList)
                data["userRequestTypeRoleList"].push(item.toJSON());
        }
        data["displayName"] = this.displayName;
        data["awaitingApproval"] = this.awaitingApproval;
        data["optInEmailNotification"] = this.optInEmailNotification;
        data["isApprover"] = this.isApprover;
        return data;
    }
}

export interface IUserModel {
    userId?: number;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    isEnabled?: boolean;
    regionId?: number;
    regionName?: string | undefined;
    countryId?: number;
    countryName?: string | undefined;
    supervisorName?: string | undefined;
    functionId?: number;
    functionName?: string | undefined;
    createdDate?: Date;
    userRequestTypeRoleList?: UserRequestTypeRoleModel[] | undefined;
    displayName?: string | undefined;
    awaitingApproval?: boolean | undefined;
    optInEmailNotification?: boolean | undefined;
    isApprover?: boolean;
}

export class UserRequestTypeRoleModel implements IUserRequestTypeRoleModel {
    userRequestTypeRoleId?: number;
    roleId?: number;
    roleName?: string | undefined;
    userId?: number;
    requestTypeId?: number;
    requestTypeName?: string | undefined;

    constructor(data?: IUserRequestTypeRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.userRequestTypeRoleId = _data["userRequestTypeRoleId"];
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.userId = _data["userId"];
            this.requestTypeId = _data["requestTypeId"];
            this.requestTypeName = _data["requestTypeName"];
        }
    }

    static fromJS(data: any, _mappings?: any): UserRequestTypeRoleModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<UserRequestTypeRoleModel>(data, _mappings, UserRequestTypeRoleModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userRequestTypeRoleId"] = this.userRequestTypeRoleId;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["userId"] = this.userId;
        data["requestTypeId"] = this.requestTypeId;
        data["requestTypeName"] = this.requestTypeName;
        return data;
    }
}

export interface IUserRequestTypeRoleModel {
    userRequestTypeRoleId?: number;
    roleId?: number;
    roleName?: string | undefined;
    userId?: number;
    requestTypeId?: number;
    requestTypeName?: string | undefined;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}